/**
=========================================================
* Select Data for the onboarding flow
=========================================================
*/

import fers from 'assets/images/fers.png'
import csrs from 'assets/images/csrs.png'
import naTableLogo from 'assets/images/logos/north_american_leaf.png'
import lincolnTableLogo from 'assets/images/logos/lincoln_logo_only.png'
import aeTableLogo from 'assets/images/logos/american_equity_logo_only.png'

export const general = {
  yesNo: [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
  ],
  yesNoUnknown: [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
    { value: 'unknown', label: "I Don't Know" },
  ],
  relationshipStatus: [
    { value: 'single', label: 'Single' },
    { value: 'married', label: 'Married' },
    { value: 'divorced', label: 'Divorced' },
    { value: 'widow', label: 'Widow/Widower' },
  ],
  gender: [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'prefernottosay', label: 'Prefer Not To Say' },
    { value: 'other', label: 'Other' },
  ],
  employmentStatus: [
    { value: 'employed', label: 'Employed' },
    { value: 'retired', label: 'Retired' },
  ],
  productOwner: [
    { value: 'self', label: 'Self' },
    { value: 'spouse', label: 'Spouse' },
  ],

  retirementStrategist: [
    {
      value: 'john_mantia',
      label: 'John Mantia',
      firstName: 'John',
      lastName: 'Mantia',
      email: 'jmantia@goparco.com',
      phone: '2026883056',
      id: 500016967,
      sfId: '0056g000001hbFw',
      npnNumber: '18539410',
    },
    {
      value: 'daniel_hampel',
      label: 'Daniel Hampel',
      firstName: 'Daniel',
      lastName: 'Hampel',
      email: 'dhampel@goparco.com',
      phone: '2026881990',
      id: 500016971,
      sfId: '0056g000001gFHZ',
      npnNumber: '',
    },
    {
      value: 'quinn_ackerman',
      label: 'Quinn Ackerman',
      firstName: 'Quinn',
      lastName: 'Ackerman',
      email: 'qackerman@goparco.com',
      phone: '2027179801',
      id: 500018329,
      sfId: '0056g000001hdQz',
      npnNumber: '',
    },
    {
      value: 'joseph_andrews',
      label: 'Joseph Andrews',
      firstName: 'Joseph',
      lastName: 'Andrews',
      email: 'jandrews@goparco.com',
      phone: '2026026163',
      id: 500028526,
      sfId: '005Uw00000D06KT',
      npnNumber: '21546257',
    },
    {
      value: 'molli_trafton',
      label: 'Molli Trafton',
      firstName: 'Molli',
      lastName: 'Trafton',
      email: 'mtrafton@goparco.com',
      phone: '2026026163',
      id: 500028526,
      sfId: '005Uw00000JAYbm',
      npnNumber: '',
    },
    {
      value: 'lauren_fulcher',
      label: 'Lauren Fulcher',
      firstName: 'Lauren',
      lastName: 'Fulcher',
      email: 'lfulcher@goparco.com',
      phone: '2029220141',
      id: 500027740,
      sfId: '005Uw000004gchh',
      npnNumber: '',
    },
    // {
    //   value: 'zach_burklund',
    //   label: 'Zach Burklund',
    //   email: 'test@goparco.com',
    //   id: 1,
    //   sfId: '0054v00000DyXih',
    // },
    { value: '', label: 'None', email: '', id: 0 },
  ],
  accountStatus: [
    { value: 'new', label: 'New' },
    { value: 'scheduled_ic', label: 'Scheduled IC' },
    { value: 'cold', label: 'Cold' },
  ],
  giftCards: [
    {
      value: 'amazon',
      label: 'Amazon',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg',
      alt: 'Amazon Logo',
    },
    {
      value: 'target',
      label: 'Target',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c5/Target_Corporation_logo_%28vector%29.svg',
      alt: 'Target Logo',
    },
    {
      value: 'walmart',
      label: 'Walmart',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/6/60/Walmart_spark_%282025%29.svg',
      alt: 'Walmart Logo',
    },
    {
      value: 'panera',
      label: 'Panera',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/4/49/Panera_Bread_wordmark.svg',
      alt: 'Panera Bread Logo',
    },
    {
      value: 'tjmaxx',
      label: 'TJ Maxx',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/1/17/TJ_Maxx_Logo.svg',
      alt: 'TJ Maxx Logo',
    },
    {
      value: 'starbucks',
      label: 'Starbucks',
      logo: 'https://upload.wikimedia.org/wikipedia/en/d/d3/Starbucks_Corporation_Logo_2011.svg',
      alt: 'Starbucks Logo',
    },
    {
      value: 'macys',
      label: 'Macys',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a6/Macy%27s_logo.svg',
      alt: 'Macys Logo',
    },
    {
      value: 'lowes',
      label: 'Lowes',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2c/Lowes_Companies_Logo.svg',
      alt: 'Lowes Logo',
    },
    {
      value: 'bassproshop',
      label: 'Bass Pro Shop',
      logo: 'https://upload.wikimedia.org/wikipedia/en/b/bf/BPS_Signature_Logo_NEW.png',
      alt: 'Bass Pro Shop Logo',
    },
    {
      value: 'homedepot',
      label: 'Home Depot',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/5/5f/TheHomeDepot.svg',
      alt: 'The Home Depot Logo',
    },
  ],
  meetingOptions: [
    {
      value: 'google_meet',
      label: 'Google Meet',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/9/9b/Google_Meet_icon_%282020%29.svg',
      alt: 'Google Meet Logo',
    },
    {
      value: 'zoom',
      label: 'Zoom',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/1/11/Zoom_Logo_2022.svg',
      alt: 'Zoom Logo',
    },
    {
      value: 'ms_teams',
      label: 'Microsoft Teams',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c9/Microsoft_Office_Teams_%282018%E2%80%93present%29.svg',
      alt: 'Microsoft Teams Logo',
    },
  ],
  retirementObjectives: [
    {
      value: 'maximize_inheritance',
      label: 'Continue Investing Most Funds to Maximize Inheritance for Family',
    },
    {
      value: 'long_term_care',
      label:
        'Ensure That Long Term Care Costs Are Covered If/When the Time Comes',
    },
    {
      value: 'maintain_lifestyle',
      label:
        'Maintain Current Lifestyle and Supplement Some Lost Income with Withdrawals',
    },
    {
      value: 'charity',
      label:
        'Spend More Time with the Church, Have a Strong Long Term Care Plan',
    },
  ],
  annuityCarriers: [
    // { value: '', label: 'Carrier' },
    {
      value: 'allianz',
      label: 'Allianz',
      logo: 'https://cdn.signalapis.com/images/carriers/allianz.png',
      tableLogo: 'https://cdn.signalapis.com/images/carriers/allianz.png',
      deckLogo:
        'https://cdn.jsdelivr.net/gh/zburklund/carrier-gradients/images/allianz.png',
      hasIncomeProducts: true,
      hasAccumulationProducts: true,
      isMapped: true,
      automationUrl: 'allianz',
      textColor: '#0671ad',
      textRGB: { red: 0.023, green: 0.443, blue: 0.678 },
      backgroundColor: '#e5f5ff',
      backgroundRGB: { red: 0.898, green: 0.961, blue: 1.0 },
    },
    {
      value: 'american_equity',
      label: 'American Equity',
      logo: 'https://cdn.signalapis.com/images/carriers/ael_american_equity.png',
      tableLogo: aeTableLogo,
      deckLogo:
        'https://cdn.jsdelivr.net/gh/zburklund/carrier-gradients/images/american-equity.png',
      hasIncomeProducts: true,
      hasAccumulationProducts: false,
      isMapped: true,
      automationUrl: 'americanequity',
      textColor: '#1b4480',
      textRGB: { red: 0.106, green: 0.267, blue: 0.502 },
      backgroundColor: '#e9f0fa',
      backgroundRGB: { red: 0.914, green: 0.941, blue: 0.98 },
    },
    {
      value: 'athene',
      label: 'Athene',
      logo: 'https://cdn.signalapis.com/images/carriers/athene.png',
      tableLogo: 'https://cdn.signalapis.com/images/carriers/athene.png',
      deckLogo:
        'https://cdn.jsdelivr.net/gh/zburklund/carrier-gradients/images/athene.png',
      hasIncomeProducts: true,
      hasAccumulationProducts: false,
      isMapped: true,
      automationUrl: 'athene',
      textColor: '#1b4480',
      textRGB: { red: 0.106, green: 0.267, blue: 0.502 },
      backgroundColor: '#e9f0fa',
      backgroundRGB: { red: 0.914, green: 0.941, blue: 0.98 },
    },
    {
      value: 'fidelity_guaranty_life',
      label: 'Fidelity & Guaranty Life',
      logo: 'https://cdn.signalapis.com/images/carriers/fidelity_guaranty_life.png',
      tableLogo:
        'https://cdn.signalapis.com/images/carriers/fidelity_guaranty_life.png',
      deckLogo:
        'https://cdn.signalapis.com/images/carriers/fidelity_guaranty_life.png',
      hasIncomeProducts: true,
      hasAccumulationProducts: false,
      isMapped: true,
      automationUrl: 'fidelityguaranty',
      textColor: '#674ea7',
      textRGB: { red: 0.404, green: 0.306, blue: 0.655 },
      backgroundColor: '#f5f2fa',
      backgroundRGB: { red: 0.961, green: 0.949, blue: 0.98 },
    },
    {
      value: 'lincoln_financial',
      label: 'Lincoln Financial',
      logo: 'https://cdn.signalapis.com/images/carriers/lincoln_financial.png',
      tableLogo: lincolnTableLogo,
      deckLogo:
        'https://cdn.jsdelivr.net/gh/zburklund/carrier-gradients/images/lincoln.png',
      hasIncomeProducts: false,
      hasAccumulationProducts: true,
      isMapped: true,
      automationUrl: 'lincoln',
      textColor: '#ff4f15',
      textRGB: { red: 1.0, green: 0.31, blue: 0.082 },
      backgroundColor: '#faf4f2',
      backgroundRGB: { red: 0.98, green: 0.957, blue: 0.949 },
    },
    {
      value: 'north_american',
      label: 'North American',
      logo: 'https://cdn.signalapis.com/images/carriers/sammons_financial.png',
      tableLogo: naTableLogo,
      deckLogo:
        'https://cdn.signalapis.com/images/carriers/sammons_financial.png',
      hasIncomeProducts: true,
      hasAccumulationProducts: true,
      isMapped: true,
      automationUrl: 'northamerican',
      textColor: '#38761d',
      textRGB: { red: 0.22, green: 0.463, blue: 0.114 },
      backgroundColor: '#e8f8e2',
      backgroundRGB: { red: 0.91, green: 0.973, blue: 0.886 },
    },
    {
      value: 'pacific_life',
      label: 'Pacific Life',
      logo: 'https://cdn.signalapis.com/images/carriers/pacific_life.png',
      tableLogo: 'https://cdn.signalapis.com/images/carriers/pacific_life.png',
      deckLogo: 'https://cdn.signalapis.com/images/carriers/pacific_life.png',
      hasIncomeProducts: false,
      hasAccumulationProducts: true,
      isMapped: false,
      automationUrl: 'pacificlife',
      textColor: '#0671ad',
      textRGB: { red: 0.023, green: 0.443, blue: 0.678 },
      backgroundColor: '#e5f5ff',
      backgroundRGB: { red: 0.898, green: 0.961, blue: 1.0 },
    },
    {
      value: 'other',
      label: 'Other',
      logo: '',
      tableLogo: '',
      deckLogo: '',
      hasIncomeProducts: false,
      hasAccumulationProducts: false,
      isMapped: false,
      automationUrl: 'other',
      textColor: '#0671ad',
      textRGB: { red: 0.023, green: 0.443, blue: 0.678 },
      backgroundColor: '#e5f5ff',
      backgroundRGB: { red: 0.898, green: 0.961, blue: 1.0 },
    },
  ],
  annuityOptions: [
    // { value: '', label: 'Annuity Choice' },
    {
      value: 'accumulation_advantage_10',
      label: 'Accumulation Advantage 10',
      provider: 'allianz',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'allianz_222_+_annuity',
      label: 'Allianz 222 + Annuity',
      provider: 'allianz',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'allianz_accumulation_advantage_+',
      label: 'Allianz Accumulation Advantage +',
      provider: 'allianz',
      isIncome: false,
      isAccumulation: true,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'allianz_accumulation_advantage_7',
      label: 'Allianz Accumulation Advantage 7',
      provider: 'allianz',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'allianz_benefit_control_+_annuity',
      label: 'Allianz Benefit Control + Annuity',
      provider: 'allianz',
      isIncome: true,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `If Can't Complete 2 of 6 ADLs`,
        fixedRate: '4.75%',
        feeFreeAccess: '10.00%',
        share: 'Unique Strategy',
        vp2: 'Guaranteed Lifetime Income',
        vp3: 'Strong Income, No Fee',
        vp4: '2 of 6 ADL Doubler',
      },
    },
    {
      value: 'allianz_benefit_control_annuity',
      label: 'Allianz Benefit Control Annuity',
      provider: 'allianz',
      isIncome: true,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `If Can't Complete 2 of 6 ADLs`,
        fixedRate: '4.75%',
        feeFreeAccess: '10.00%',
        share: 'Unique Strategy',
        vp2: 'Guaranteed Lifetime Income',
        vp3: 'Strong Income, No Fee',
        vp4: '2 of 6 ADL Doubler',
      },
    },
    {
      value: 'core_income_7',
      label: 'Core Income 7',
      provider: 'allianz',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'retirement_foundation_adv',
      label: 'Retirement Foundation ADV',
      provider: 'allianz',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'allianz_360_annuity',
      label: 'Allianz 360 Annuity',
      provider: 'allianz',
      isIncome: true,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: '0.95%',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: 'Guaranteed Lifetime Income',
        vp3: 'Stronger Income, 0.95% Fee',
        vp4: 'No Extra Bells & Whistles',
      },
    },
    {
      value: 'ael_assetshield_10',
      label: 'AEL AssetShield 10',
      provider: 'american_equity',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'ael_assetshield_5',
      label: 'AEL AssetShield 5',
      provider: 'american_equity',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'ael_assetshield_7',
      label: 'AEL AssetShield 7',
      provider: 'american_equity',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'ael_assetshield_bonus_10',
      label: 'AEL AssetShield Bonus 10',
      provider: 'american_equity',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'ael_assetshield_bonus_10_with_eblr',
      label: 'AEL AssetShield Bonus 10 with EBLR',
      provider: 'american_equity',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'ael_balanceshield',
      label: 'AEL BalanceShield',
      provider: 'american_equity',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'ael_estateshield_10',
      label: 'AEL EstateShield 10',
      provider: 'american_equity',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'ael_incomeshield_10-_libr_2020',
      label: 'AEL IncomeShield 10- LIBR 2020',
      provider: 'american_equity',
      isIncome: true,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `If Can't Complete 2 of 6 ADLs`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: 'Guaranteed Lifetime Income',
        vp3: 'Strong Income, No Fee',
        vp4: '2 of 6 ADL Doubler',
      },
    },
    {
      value: 'ael_incomeshield_7_2020',
      label: 'AEL IncomeShield 7 2020',
      provider: 'american_equity',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'ael_incomeshield_10_-_no_libr',
      label: 'AEL IncomeShield 10 - No LIBR',
      provider: 'american_equity',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'ascent_pro_10_bonus',
      label: 'Ascent Pro 10 Bonus',
      provider: 'athene',
      isIncome: true,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: '1.00%',
        doublerText: `If Can't Complete 2 of 6 ADLs`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: 'Guaranteed Lifetime Income',
        vp3: 'Stronger Income, 1.00% Fee',
        vp4: '2 of 6 ADL Doubler',
      },
    },
    {
      value: 'athene_accumax_7',
      label: 'Athene AccuMax 7',
      provider: 'athene',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'athene_agility_10',
      label: 'Athene Agility 10',
      provider: 'athene',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'athene_agility_7',
      label: 'Athene Agility 7',
      provider: 'athene',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'athene_velocity',
      label: 'Athene Velocity',
      provider: 'athene',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'bca_10_2.0',
      label: 'BCA 10 2.0',
      provider: 'athene',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'bca_12_2.0',
      label: 'BCA 12 2.0',
      provider: 'athene',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'bca_6_2.0',
      label: 'BCA 6 2.0',
      provider: 'athene',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'bca_8_2.0',
      label: 'BCA 8 2.0',
      provider: 'athene',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'performance_elite_10',
      label: 'Performance Elite 10',
      provider: 'athene',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'performance_elite_15',
      label: 'Performance Elite 15',
      provider: 'athene',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'performance_elite_7',
      label: 'Performance Elite 7',
      provider: 'athene',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'performance_elite_plus_10',
      label: 'Performance Elite Plus 10',
      provider: 'athene',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'performance_elite_plus_15',
      label: 'Performance Elite Plus 15',
      provider: 'athene',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'performance_elite_plus_7',
      label: 'Performance Elite Plus 7',
      provider: 'athene',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'accelerator_pus_10',
      label: 'Accelerator Pus 10',
      provider: 'fidelity_guaranty_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'accelerator_pus_14',
      label: 'Accelerator Pus 14',
      provider: 'fidelity_guaranty_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'accumulator_plus_10',
      label: 'Accumulator Plus 10',
      provider: 'fidelity_guaranty_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'accumulator_plus_7',
      label: 'Accumulator Plus 7',
      provider: 'fidelity_guaranty_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'f&g_1-2-3',
      label: 'F&G 1-2-3',
      provider: 'fidelity_guaranty_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'flex_accumulator',
      label: 'Flex Accumulator',
      provider: 'fidelity_guaranty_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'performance_pro',
      label: 'Performance Pro',
      provider: 'fidelity_guaranty_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'power_accumulator_10',
      label: 'Power Accumulator 10',
      provider: 'fidelity_guaranty_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'power_accumulator_7',
      label: 'Power Accumulator 7',
      provider: 'fidelity_guaranty_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'prosperity_elite_10',
      label: 'Prosperity Elite 10',
      provider: 'fidelity_guaranty_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'prosperity_elite_14',
      label: 'Prosperity Elite 14',
      provider: 'fidelity_guaranty_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'prosperity_elite_7',
      label: 'Prosperity Elite 7',
      provider: 'fidelity_guaranty_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'safe_income_advantage',
      label: 'Safe Income Advantage',
      provider: 'fidelity_guaranty_life',
      isIncome: true,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: '1.15%',
        doublerText: `If Can't Complete 2 of 6 ADLs`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: 'Guaranteed Lifetime Income',
        vp3: 'Stronger Income, 1.15% Fee',
        vp4: '2 of 6 ADL Doubler',
      },
    },
    {
      value: 'optiblend_10',
      label: 'OptiBlend 10',
      provider: 'lincoln_financial',
      isIncome: false,
      isAccumulation: true,
      isMapped: false,
      strategyType: 'cap',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '4.30%',
        feeFreeAccess: '10.00%',
        share: '9.55%',
        vp2: '9.55% S&P 500 Cap',
        vp3: '10.00% Access Each Year',
        vp4: 'No Account Fee',
      },
    },
    {
      value: 'optiblend_5',
      label: 'OptiBlend 5',
      provider: 'lincoln_financial',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'optiblend_7',
      label: 'OptiBlend 7',
      provider: 'lincoln_financial',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'benefitsolutions_10',
      label: 'BenefitSolutions 10',
      provider: 'north_american',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'charter_plus_10',
      label: 'Charter Plus 10',
      provider: 'north_american',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'nac_control._x',
      label: 'NAC Control. X',
      provider: 'north_american',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'nac_guaranteed_allocation_10',
      label: 'NAC Guaranteed Allocation 10',
      provider: 'north_american',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'nac_guaranteed_allocation_7',
      label: 'NAC Guaranteed Allocation 7',
      provider: 'north_american',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'nac_guaranteed_allocation_5',
      label: 'NAC Guaranteed Allocation 5',
      provider: 'north_american',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'nac_income_pay_pro',
      label: 'NAC Income Pay Pro',
      provider: 'north_american',
      isIncome: true,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: '1.15%',
        doublerText: `If Confined to a Nursing Home`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: 'Guaranteed Lifetime Income',
        vp3: 'Stronger Income, 1.15% Fee',
        vp4: 'Nursing Home Doubler',
      },
    },
    {
      value: 'north_american_secure_horizon_accelerator',
      label: 'North American Secure Horizon Accelerator',
      provider: 'north_american',
      isIncome: false,
      isAccumulation: true,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'north_american_secure_horizon_choice_5',
      label: 'North American Secure Horizon Choice 5',
      provider: 'north_american',
      isIncome: false,
      isAccumulation: true,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'north_american_secure_horizon_choice_7',
      label: 'North American Secure Horizon Choice 7',
      provider: 'north_american',
      isIncome: false,
      isAccumulation: true,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'performance_choice_8',
      label: 'Performance Choice 8',
      provider: 'north_american',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'primepath_pro_10',
      label: 'PrimePath Pro 10',
      provider: 'north_american',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'secure_horizon',
      label: 'Secure Horizon',
      provider: 'north_american',
      isIncome: false,
      isAccumulation: true,
      isMapped: true,
      strategyType: 'ladder',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '3.70%',
        feeFreeAccess: '7.00%',
        share: 'Unique Strategy',
        vp2: 'Performance Ladder Strategy',
        vp3: '7.00% Access Each Year',
        vp4: 'No Account Fee',
      },
    },
    {
      value: 'secure_horizon_plus',
      label: 'Secure Horizon Plus',
      provider: 'north_american',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'versachoice_10',
      label: 'VersaChoice 10',
      provider: 'north_american',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'income_provider',
      label: 'Income Provider',
      provider: 'pacific_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'index_dimensions',
      label: 'Index Dimensions',
      provider: 'pacific_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'index_foundation_10',
      label: 'Index Foundation 10',
      provider: 'pacific_life',
      isIncome: false,
      isAccumulation: true,
      isMapped: false,
      strategyType: 'trigger',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '4.00%',
        feeFreeAccess: '10.00%',
        share: '7.4%',
        vp2: '7.4% S&P 500 Performance Trigger',
        vp3: '10.00% Access Each Year',
        vp4: 'No Account Fee',
      },
    },
    {
      value: 'index_foundation_5',
      label: 'Index Foundation 5',
      provider: 'pacific_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'index_foundation_7',
      label: 'Index Foundation 7',
      provider: 'pacific_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'pacific_secure_income',
      label: 'Pacific Secure Income',
      provider: 'pacific_life',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
    {
      value: 'other',
      label: 'Other',
      provider: 'other',
      isIncome: false,
      isAccumulation: false,
      isMapped: false,
      strategyType: 'none',
      valuePoints: {
        carrierRating: 'A+',
        annualFee: 'No',
        doublerText: `None`,
        fixedRate: '0.00%',
        feeFreeAccess: '0.00%',
        share: 'Unique Strategy',
        vp2: '',
        vp3: '',
        vp4: '',
      },
    },
  ],
  balanceSheetType: [
    { value: 'asset', label: 'Asset' },
    { value: 'liability', label: 'Liability' },
    { value: 'income', label: 'Income' },
    { value: 'expense', label: 'Expense' },
  ],
  balanceSheetSubType: [
    { value: 'checkingsavings', label: 'Checking & Savings', subType: 'asset' },
    { value: 'property', label: 'Property', subType: 'asset' },
    { value: 'investment', label: 'Investment', subType: 'asset' },
    { value: 'otherassets', label: 'Other Assets', subType: 'asset' },
    { value: 'mortgage', label: 'Mortgage', subType: 'liability' },
    { value: 'creditcard', label: 'Credit Card', subType: 'liability' },
    { value: 'tspLoan', label: 'TSP Loan', subType: 'liability' },
    {
      value: 'otherliabilities',
      label: 'Other Liabilities',
      subType: 'liability',
    },
    { value: 'annuity', label: 'Annuity', subType: 'income' },
    {
      value: 'governmentbenefit',
      label: 'Government Benefit',
      subType: 'income',
    },
    {
      value: 'investmentincome',
      label: 'Investment Income',
      subType: 'income',
    },
    { value: 'militarypension', label: 'Military Pension', subType: 'income' },
    { value: 'otherincome', label: 'Other', subType: 'income' },
    { value: 'parttimehourly', label: 'Part Time Hourly', subType: 'income' },
    { value: 'pension', label: 'Pension', subType: 'income' },
    {
      value: 'privatesectorpensioncolaadjusted',
      label: 'Private Sector Pension Cola Adjusted',
      subType: 'income',
    },
    { value: 'rentalincome', label: 'Rental Income', subType: 'income' },
    { value: 'rmd', label: 'RMD', subType: 'income' },
    { value: 'salary', label: 'Salary', subType: 'income' },
    { value: 'socialsecurity', label: 'Social Security', subType: 'income' },
    { value: 'spousalpension', label: 'Spousal Pension', subType: 'income' },
    { value: 'spousalsalary', label: 'Spousal Salary', subType: 'income' },
    {
      value: 'spousalsocialsecurity',
      label: 'Spousal Social Security',
      subType: 'income',
    },
    {
      value: 'stateemployeepension',
      label: 'State Employee Pension',
      subType: 'income',
    },
    { value: 'survivorbenefit', label: 'Survivor Benefit', subType: 'income' },
    { value: 'vadisability', label: 'VA Disability', subType: 'income' },
    { value: 'autoloan', label: 'Auto Loan', subType: 'expense' },
    { value: 'cargas', label: 'Car (Gas)', subType: 'expense' },
    { value: 'carinsurance', label: 'Car (Insurance)', subType: 'expense' },
    { value: 'carpayment', label: 'Car (Payment)', subType: 'expense' },
    { value: 'cellphone', label: 'Cell Phone', subType: 'expense' },
    { value: 'creditcard', label: 'Credit Card', subType: 'expense' },
    {
      value: 'creditcardpayment',
      label: 'Credit Card Payment',
      subType: 'expense',
    },
    {
      value: 'directconsolidationloans',
      label: 'Direct Consolidation Loans',
      subType: 'expense',
    },
    {
      value: 'directunsubsidizedloans',
      label: 'Direct Unsubsidized Loans',
      subType: 'expense',
    },
    { value: 'funmoney', label: 'Fun Money', subType: 'expense' },
    {
      value: 'graduateplusloans',
      label: 'Graduate PLUS Loans',
      subType: 'expense',
    },
    { value: 'groceries', label: 'Groceries', subType: 'expense' },
    { value: 'heloc', label: 'HELOC', subType: 'expense' },
    { value: 'mortgage', label: 'Home (Mortgage)', subType: 'expense' },
    {
      value: 'homerenovations',
      label: 'Home (Renovations)',
      subType: 'expense',
    },
    { value: 'homerent', label: 'Home (Rent)', subType: 'expense' },
    { value: 'hospitalbills', label: 'Hospital Bills', subType: 'expense' },
    { value: 'irsdebt', label: 'IRS Debt', subType: 'expense' },
    { value: 'lifeinsurance', label: 'Life Insurance', subType: 'expense' },
    { value: 'medicalexpense', label: 'Medical Expense', subType: 'expense' },
    { value: 'other', label: 'Other', subType: 'expense' },
    {
      value: 'parentplusloans',
      label: 'Parent PLUS Loans',
      subType: 'expense',
    },
    { value: 'paydayloan', label: 'Payday Loan', subType: 'expense' },
    { value: 'petcare', label: 'Pet Care', subType: 'expense' },
    { value: 'primarymortgage', label: 'Primary Mortgage', subType: 'expense' },
    {
      value: 'privatestudentloan',
      label: 'Private Student Loan',
      subType: 'expense',
    },
    { value: 'restaurant', label: 'Restaurant', subType: 'expense' },
    {
      value: 'secondarymortgage',
      label: 'Secondary Mortgage',
      subType: 'expense',
    },
    { value: 'travelplans', label: 'Travel Plans', subType: 'expense' },
    { value: 'utilities', label: 'Utilities', subType: 'expense' },
    {
      value: 'tsploangeneralpurpose',
      label: 'TSP Loan (General Purpose)',
      subType: 'expense',
    },
    {
      value: 'tsploanresidential',
      label: 'TSP Loan (Residential)',
      subType: 'expense',
    },
  ],
  balanceSheetSubTypeClassification: [
    {
      value: '403(b)',
      label: '403(b)',
      investable: true,
      accountType: 'traditional',
      includeInLegacyPlanning: true,
      subType: 'investment',
      listToAppear: 'otherassets',
    },
    {
      value: '457(b)',
      label: '457(b)',
      investable: true,
      accountType: 'traditional',
      includeInLegacyPlanning: true,
      subType: 'investment',
      listToAppear: 'otherassets',
    },
    {
      value: 'ira-traditional',
      label: 'IRA - Traditional',
      investable: true,
      accountType: 'traditional',
      includeInLegacyPlanning: true,
      subType: 'investment',
      listToAppear: 'investment',
    },
    {
      value: 'ira-roth',
      label: 'IRA - Roth',
      investable: true,
      accountType: 'roth',
      includeInLegacyPlanning: true,
      subType: 'investment',
      listToAppear: 'investment',
    },
    {
      value: 'sepira',
      label: 'SEP IRA',
      investable: true,
      accountType: 'traditional',
      includeInLegacyPlanning: true,
      subType: 'investment',
      listToAppear: 'otherassets',
    },
    {
      value: 'brokerageaccount',
      label: 'Brokerage Account',
      investable: true,
      accountType: 'non-qualified',
      includeInLegacyPlanning: true,
      subType: 'investment',
      listToAppear: 'investment',
    },
    {
      value: 'annuity',
      label: 'Annuity',
      investable: true,
      accountType: 'annuity',
      includeInLegacyPlanning: true,
      subType: 'investment',
      listToAppear: 'investment',
    },
    {
      value: '401(k)',
      label: '401(k)',
      investable: true,
      accountType: 'traditional',
      includeInLegacyPlanning: true,
      subType: 'investment',
      listToAppear: 'otherassets',
    },
    {
      value: '401(k)-tsptraditional',
      label: '401(k) - TSP Traditional',
      investable: true,
      accountType: 'traditional',
      includeInLegacyPlanning: true,
      subType: 'investment',
      listToAppear: 'investment',
    },
    {
      value: '401(k)-tsproth',
      label: '401(k) - TSP Roth',
      investable: true,
      accountType: 'roth',
      includeInLegacyPlanning: true,
      subType: 'investment',
      listToAppear: 'investment',
    },
    {
      value: '529savingsplan',
      label: '529 Savings Plan',
      investable: true,
      accountType: 'traditional',
      includeInLegacyPlanning: true,
      subType: 'investment',
      listToAppear: 'otherassets',
    },
    {
      value: 'savingsaccount',
      label: 'Savings Account',
      investable: true,
      accountType: 'non-qualified',
      includeInLegacyPlanning: true,
      subType: 'checkingsavings',
      listToAppear: 'checkingsavings',
    },
    {
      value: 'checkingaccount',
      label: 'Checking Account',
      investable: true,
      accountType: 'non-qualified',
      includeInLegacyPlanning: true,
      subType: 'checkingsavings',
      listToAppear: 'checkingsavings',
    },
    {
      value: 'cash',
      label: 'Cash',
      investable: true,
      accountType: 'non-qualified',
      includeInLegacyPlanning: true,
      subType: 'checkingsavings',
      listToAppear: 'checkingsavings',
    },
    {
      value: 'cd',
      label: 'CD',
      investable: true,
      accountType: 'non-qualified',
      includeInLegacyPlanning: true,
      subType: 'checkingsavings',
      listToAppear: 'checkingsavings',
    },
    {
      value: 'primaryresidence',
      label: 'Primary Residence',
      investable: false,
      accountType: 'non-qualified',
      includeInLegacyPlanning: false,
      subType: 'property',
      listToAppear: 'property',
    },
    {
      value: 'otherresidence',
      label: 'Other Residence',
      investable: false,
      accountType: 'non-qualified',
      includeInLegacyPlanning: true,
      subType: 'property',
      listToAppear: 'property',
    },
    {
      value: 'gold',
      label: 'Gold',
      investable: true,
      accountType: 'non-qualified',
      includeInLegacyPlanning: true,
      subType: 'otherassets',
      listToAppear: 'otherassets',
    },
    // {
    //   value: 'mutualfunds',
    //   label: 'Mutual Funds',
    //   investable: true,
    //   accountType: 'non-qualified',
    //   includeInLegacyPlanning: true,
    //   subType: 'investment',
    // },
    {
      value: 'bonds',
      label: 'Bonds',
      investable: true,
      accountType: 'non-qualified',
      includeInLegacyPlanning: true,
      subType: 'investment',
      listToAppear: 'otherassets',
    },
    {
      value: 'art',
      label: 'Art',
      investable: false,
      accountType: 'non-qualified',
      includeInLegacyPlanning: false,
      subType: 'otherassets',
      listToAppear: 'otherassets',
    },
    {
      value: 'collectorcars',
      label: 'Collector Cars',
      investable: false,
      accountType: 'non-qualified',
      includeInLegacyPlanning: false,
      subType: 'otherassets',
      listToAppear: 'otherassets',
    },
    {
      value: 'other',
      label: 'Other',
      investable: false,
      accountType: 'non-qualified',
      includeInLegacyPlanning: false,
      subType: 'otherassets',
      listToAppear: 'otherassets',
    },
    {
      value: 'emergencyfund-minimum',
      label: 'Emergency Fund - Minimum',
      investable: true,
      accountType: 'non-qualified',
      includeInLegacyPlanning: false,
      subType: 'checkingsavings',
      listToAppear: 'otherassets',
    },
    {
      value: 'ibonds',
      label: 'i Bonds',
      investable: true,
      accountType: 'non-qualified',
      includeInLegacyPlanning: true,
      subType: 'investment',
      listToAppear: 'otherassets',
    },
    {
      value: 'parcowealthmanagementaccount',
      label: 'PARCO Wealth Management Account',
      investable: true,
      accountType: 'qualified',
      includeInLegacyPlanning: false,
      subType: 'investment',
      listToAppear: 'otherassets',
    },
    {
      value: 'parcorecommendedbondalternative',
      label: 'PARCO Recommended Bond Alternative',
      investable: true,
      accountType: 'qualified',
      includeInLegacyPlanning: false,
      subType: 'investment',
      listToAppear: 'otherassets',
    },
    {
      value: 'inheritedira',
      label: 'Inherited IRA',
      investable: true,
      accountType: 'qualified',
      includeInLegacyPlanning: true,
      subType: 'investment',
      listToAppear: 'otherassets',
    },
    {
      value: 'hsa',
      label: 'HSA',
      investable: true,
      accountType: 'qualified',
      includeInLegacyPlanning: true,
      subType: 'investment',
      listToAppear: 'otherassets',
    },
    {
      value: 'rentalproperty',
      label: 'Rental Property',
      investable: false,
      accountType: 'non-qualified',
      includeInLegacyPlanning: true,
      subType: 'property',
      listToAppear: 'property',
    },
    // {
    //   value: 'moneymarket',
    //   label: 'Money Market',
    //   investable: true,
    //   accountType: 'non-qualified',
    //   includeInLegacyPlanning: true,
    //   subType: 'investment',
    // },
    {
      value: 'creditcard',
      label: 'Credit Card',
      subType: 'creditcard',
      listToAppear: 'creditcard',
    },
    {
      value: 'primarymortgage',
      label: 'Primary Mortgage',
      subType: 'mortgage',
      listToAppear: 'mortgage',
    },
    {
      value: 'heloc',
      label: 'HELOC',
      subType: 'mortgage',
      listToAppear: 'mortgage',
    },
    {
      value: 'paydayloan',
      label: 'Payday Loan',
      subType: 'otherliabilities',
      listToAppear: 'otherliabilities',
    },
    {
      value: 'autoloan',
      label: 'Auto Loan',
      subType: 'otherliabilities',
      listToAppear: 'otherliabilities',
    },
    {
      value: 'irsdebt',
      label: 'IRS Debt',
      subType: 'otherliabilities',
      listToAppear: 'otherliabilities',
    },
    {
      value: 'hospitalbills',
      label: 'Hospital Bills',
      subType: 'otherliabilities',
      listToAppear: 'otherliabilities',
    },
    {
      value: 'privatestudentloan',
      label: 'Private Student Loan',
      subType: 'otherliabilities',
      listToAppear: 'otherliabilities',
    },
    {
      value: 'secondarymortgage',
      label: 'Secondary Mortgage',
      subType: 'mortgage',
      listToAppear: 'mortgage',
    },
    {
      value: 'directsubsidizedloans',
      label: 'Direct Subsidized Loans',
      subType: 'otherliabilities',
      listToAppear: 'otherliabilities',
    },
    {
      value: 'directunsubsidizedloans',
      label: 'Direct Unsubsidized Loans',
      subType: 'otherliabilities',
      listToAppear: 'otherliabilities',
    },
    {
      value: 'parentplusloans',
      label: 'Parent PLUS Loans',
      subType: 'otherliabilities',
      listToAppear: 'otherliabilities',
    },
    {
      value: 'graduateplusloans',
      label: 'Graduate PLUS Loans',
      subType: 'otherliabilities',
      listToAppear: 'otherliabilities',
    },
    {
      value: 'directconsolidationloans',
      label: 'Direct Consolidation Loans',
      subType: 'otherliabilities',
      listToAppear: 'otherliabilities',
    },
    {
      value: 'tsploan-residential',
      label: 'TSP Loan - Residential',
      subType: 'tspLoan',
      listToAppear: 'tspLoan',
    },
    {
      value: 'tspLoan-generalpurpose',
      label: 'TSP Loan - General Purpose',
      subType: 'tspLoan',
      listToAppear: 'tspLoan',
    },
    {
      value: 'federalstudentloans',
      label: 'Federal Student Loans',
      subType: 'otherliabilities',
      listToAppear: 'otherliabilities',
    },
    {
      value: 'personalloan',
      label: 'Personal Loan',
      subType: 'otherliabilities',
      listToAppear: 'otherliabilities',
    },
    {
      value: 'medicaldebt',
      label: 'Medical Debt',
      subType: 'otherliabilities',
      listToAppear: 'otherliabilities',
    },
    {
      value: 'other',
      label: 'Other',
      subType: 'otherliabilities',
      listToAppear: 'otherliabilities',
    },
  ],
  survivorBenefitElection: [
    { value: 'full', label: 'Full' },
    { value: 'partial', label: 'Partial' },
    { value: 'none', label: 'None' },
    { value: 'notsure', label: `I'm not sure` },
  ],
  datesDay: [
    { value: '01', label: '1' },
    { value: '02', label: '2' },
    { value: '03', label: '3' },
    { value: '04', label: '4' },
    { value: '05', label: '5' },
    { value: '06', label: '6' },
    { value: '07', label: '7' },
    { value: '08', label: '8' },
    { value: '09', label: '9' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
    { value: '13', label: '13' },
    { value: '14', label: '14' },
    { value: '15', label: '15' },
    { value: '16', label: '16' },
    { value: '17', label: '17' },
    { value: '18', label: '18' },
    { value: '19', label: '19' },
    { value: '20', label: '20' },
    { value: '21', label: '21' },
    { value: '22', label: '22' },
    { value: '23', label: '23' },
    { value: '24', label: '24' },
    { value: '25', label: '25' },
    { value: '26', label: '26' },
    { value: '27', label: '27' },
    { value: '28', label: '28' },
    { value: '29', label: '29' },
    { value: '30', label: '30' },
    { value: '31', label: '31' },
  ],
  datesMonth: [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ],
  datesYear: [
    { value: '1944', label: '1944' },
    { value: '1945', label: '1945' },
    { value: '1946', label: '1946' },
    { value: '1947', label: '1947' },
    { value: '1948', label: '1948' },
    { value: '1949', label: '1949' },
    { value: '1950', label: '1950' },
    { value: '1951', label: '1951' },
    { value: '1952', label: '1952' },
    { value: '1953', label: '1953' },
    { value: '1954', label: '1954' },
    { value: '1955', label: '1955' },
    { value: '1956', label: '1956' },
    { value: '1957', label: '1957' },
    { value: '1958', label: '1958' },
    { value: '1959', label: '1959' },
    { value: '1960', label: '1960' },
    { value: '1961', label: '1961' },
    { value: '1962', label: '1962' },
    { value: '1963', label: '1963' },
    { value: '1964', label: '1964' },
    { value: '1965', label: '1965' },
    { value: '1966', label: '1966' },
    { value: '1967', label: '1967' },
    { value: '1968', label: '1968' },
    { value: '1969', label: '1969' },
    { value: '1970', label: '1970' },
    { value: '1971', label: '1971' },
    { value: '1972', label: '1972' },
    { value: '1973', label: '1973' },
    { value: '1974', label: '1974' },
    { value: '1975', label: '1975' },
    { value: '1976', label: '1976' },
    { value: '1977', label: '1977' },
    { value: '1978', label: '1978' },
    { value: '1979', label: '1979' },
    { value: '1980', label: '1980' },
    { value: '1981', label: '1981' },
    { value: '1982', label: '1982' },
    { value: '1983', label: '1983' },
    { value: '1984', label: '1984' },
    { value: '1985', label: '1985' },
    { value: '1986', label: '1986' },
    { value: '1987', label: '1987' },
    { value: '1988', label: '1988' },
    { value: '1989', label: '1989' },
    { value: '1990', label: '1990' },
    { value: '1991', label: '1991' },
    { value: '1992', label: '1992' },
    { value: '1993', label: '1993' },
    { value: '1994', label: '1994' },
    { value: '1995', label: '1995' },
    { value: '1996', label: '1996' },
    { value: '1997', label: '1997' },
    { value: '1998', label: '1998' },
    { value: '1999', label: '1999' },
    { value: '2000', label: '2000' },
    { value: '2001', label: '2001' },
    { value: '2002', label: '2002' },
    { value: '2003', label: '2003' },
    { value: '2004', label: '2004' },
    { value: '2005', label: '2005' },
    { value: '2006', label: '2006' },
    { value: '2007', label: '2007' },
    { value: '2008', label: '2008' },
    { value: '2009', label: '2009' },
    { value: '2010', label: '2010' },
    { value: '2011', label: '2011' },
    { value: '2012', label: '2012' },
    { value: '2013', label: '2013' },
    { value: '2014', label: '2014' },
    { value: '2015', label: '2015' },
    { value: '2016', label: '2016' },
    { value: '2017', label: '2017' },
    { value: '2018', label: '2018' },
    { value: '2019', label: '2019' },
    { value: '2020', label: '2020' },
    { value: '2021', label: '2021' },
    { value: '2022', label: '2022' },
    { value: '2023', label: '2023' },
    { value: '2024', label: '2024' },
    { value: '2025', label: '2025' },
    { value: '2026', label: '2026' },
    { value: '2027', label: '2027' },
    { value: '2028', label: '2028' },
    { value: '2029', label: '2029' },
    { value: '2030', label: '2030' },
    { value: '2031', label: '2031' },
    { value: '2032', label: '2032' },
    { value: '2033', label: '2033' },
    { value: '2034', label: '2034' },
    { value: '2035', label: '2035' },
    { value: '2036', label: '2036' },
    { value: '2037', label: '2037' },
    { value: '2038', label: '2038' },
    { value: '2039', label: '2039' },
    { value: '2040', label: '2040' },
    { value: '2041', label: '2041' },
    { value: '2042', label: '2042' },
    { value: '2043', label: '2043' },
    { value: '2044', label: '2044' },
    { value: '2045', label: '2045' },
    { value: '2046', label: '2046' },
    { value: '2047', label: '2047' },
    { value: '2048', label: '2048' },
    { value: '2049', label: '2049' },
    { value: '2050', label: '2050' },
    { value: '2051', label: '2051' },
    { value: '2052', label: '2052' },
    { value: '2053', label: '2053' },
    { value: '2054', label: '2054' },
    { value: '2055', label: '2055' },
    { value: '2056', label: '2056' },
    { value: '2057', label: '2057' },
    { value: '2058', label: '2058' },
    { value: '2059', label: '2059' },
    { value: '2060', label: '2060' },
    { value: '2061', label: '2061' },
    { value: '2062', label: '2062' },
    { value: '2063', label: '2063' },
    { value: '2064', label: '2064' },
  ],
  retirementSSMonth: [
    { value: 0, label: '0' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '10' },
    { value: 11, label: '11' },
    { value: 12, label: '12' },
  ],
  retirementSSYear: [
    { value: 62, label: '62' },
    { value: 63, label: '63' },
    { value: 64, label: '64' },
    { value: 65, label: '65' },
    { value: 66, label: '66' },
    { value: 67, label: '67' },
    { value: 68, label: '68' },
    { value: 69, label: '69' },
    { value: 70, label: '70' },
  ],
  militaryBranch: [
    {
      value: 'unitedstatesairforce',
      label: 'United States Air Force',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/d/d4/US_Air_Force_Reserve_Badge.png',
    },
    {
      value: 'unitedstatesnavy',
      label: 'United States Navy',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b1/Emblem_of_the_United_States_Navy.svg',
    },
    {
      value: 'unitedstatesarmy',
      label: 'United States Army',
      logo: 'https://www.army.mil/e2/global/rv7/brand/army_logo_horiz.svg',
    },
    {
      value: 'unitedstatesmarinecorps',
      label: 'United States Marine Corps',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/9/90/Seal_of_the_US_Marine_Corps.svg',
    },
    {
      value: 'unitedstatesspaceforce',
      label: 'United States Space Force',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/archive/5/5a/20200723011556%21Logo_of_the_United_States_Space_Force.png',
    },
    {
      value: 'unitedstatescoastguard',
      label: 'United States Coast Guard',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/e/e5/Mark_of_the_U.S._Coast_Guard.svg',
    },
  ],
  retirementSystem: [
    {
      value: 'fers',
      label: 'FERS',
      mandatoryRetirementAge: 'No',
      logo: fers,
    },
    { value: 'csrs', label: 'CSRS', mandatoryRetirementAge: 'No', logo: csrs },
    {
      value: 'csrs_offset',
      label: 'CSRS Offset',
      mandatoryRetirementAge: 'No',
      logo: csrs,
    },
    {
      value: 'special_fers_(leo,_atc_etc.)',
      label: 'Special FERS (LEO ATC etc.)',
      mandatoryRetirementAge: 'Yes',
      logo: fers,
    },
    {
      value: 'ecbpo_(cbp_federal_employees)',
      label: 'eCBPO (CBP Federal Employees)',
      mandatoryRetirementAge: '',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/0/08/Seal_of_U.S._Customs_and_Border_Protection.png',
    },
    {
      value: 'federal_reserve_system_retirement_plan',
      label: 'Federal Reserve System Retirement Plan',
      mandatoryRetirementAge: '',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1a/Seal_of_the_United_States_Federal_Reserve_System.svg',
    },
    {
      value: 'foreign_service_officer_pension_(fsps)',
      label: 'Foreign Service Officer Pension (FSPS)',
      mandatoryRetirementAge: 'Yes',
      logo: 'https://www.state.gov/wp-content/uploads/2022/04/cropped-dos_seal-192x192.png',
    },
    {
      value: 'foreign_service_officer_limited_(fs_-_ltd)',
      label: 'Foreign Service Officer Limited (FS - LTD)',
      mandatoryRetirementAge: '',
      logo: 'https://www.state.gov/wp-content/uploads/2022/04/cropped-dos_seal-192x192.png',
    },
    {
      value: 'private_sector_-_no_pension',
      label: 'Private Sector - No Pension',
      mandatoryRetirementAge: '',
    },
    { value: 'other', label: 'Other', mandatoryRetirementAge: '' },
  ],
  retirementType: [
    { value: 'full', label: 'Full' },
    { value: 'vera', label: 'VERA' },
    { value: 'mra10', label: 'MRA+10' },
    { value: 'deferred', label: 'Deferred' },
    { value: 'disability', label: 'Disability' },
    { value: 'rif', label: 'RIF' },
    { value: 'dsr', label: 'Discontinued Service' },
    { value: 'mandatory', label: 'Mandatory' },
    { value: 'postponed', label: 'Postponed' },
  ],
  riskTolerance: [
    { value: 'very_conservative', label: 'Very Conservative' },
    { value: 'conservative', label: 'Conservative' },
    { value: 'moderate', label: 'Moderate' },
    { value: 'aggressive', label: 'Aggressive' },
    { value: 'veryaggressive', label: 'Very Aggressive' },
  ],
  healthInsurance: [
    { value: 'fehb', label: 'FEHB' },
    { value: 'tricare', label: 'Tricare' },
    { value: 'pshb', label: 'PSHB' },
    { value: 'other', label: 'Other Provider' },
  ],
  privateLifeInsuranceProviders: [
    {
      value: 'allianz',
      label: 'Allianz',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/4/4b/Allianz.svg',
    },
    {
      value: 'allstate',
      label: 'Allstate',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/8/88/Allstate_wordmark.svg',
    },
    {
      value: 'ameritas',
      label: 'Ameritas',
      logo: 'https://cdn.signalapis.com/images/carriers/ameritas.png',
    },
    {
      value: 'assurity',
      label: 'Assurity',
      logo: 'https://cdn.signalapis.com/images/carriers/assurity.png',
    },
    {
      value: 'bostonmutual',
      label: 'Boston Mutual',
      logo: 'https://www.bostonmutual.com/wp-content/themes/Boston-Mutual-2017/images/logo-copyright.png',
    },
    {
      value: 'bannerlife',
      label: 'Banner Life',
      logo: 'https://cdn.signalapis.com/images/carriers/banner_life.png',
    },
    {
      value: 'columbuslife',
      label: 'Columbus Life',
      logo: 'https://cdn.signalapis.com/images/carriers/columbus.png',
    },
    {
      value: 'corebridgefinancial',
      label: 'Corebridge Financial',
      logo: 'https://cdn.signalapis.com/images/carriers/corebridge_financial.png',
    },
    {
      value: 'guardian',
      label: 'Guardian',
      logo: 'https://images.ctfassets.net/gau1nv66ynug/5Dx7un7ad6f1T3ZBBBrDAe/e615c41101bb4a33fc1c4a9c4efcb8f4/Guardian-logo-dark.png',
    },
    {
      value: 'fidelity&guarantylife',
      label: 'Fidelity & Guaranty Life',
      logo: 'https://cdn.signalapis.com/images/carriers/fidelity_guaranty_life.png',
    },
    {
      value: 'forestersfinancial',
      label: 'Foresters Financial',
      logo: 'https://cdn.signalapis.com/images/carriers/foresters_financial.png',
    },
    {
      value: 'johnhancock',
      label: 'John Hancock',
      logo: 'https://cdn.signalapis.com/images/carriers/john_hancock.png',
    },
    {
      value: 'lincolnfinancial',
      label: 'Lincoln Financial',
      logo: 'https://cdn.signalapis.com/images/carriers/lincoln_financial.png',
    },
    {
      value: 'massmutual',
      label: 'Mass Mutual',
      logo: 'https://cdn.signalapis.com/images/carriers/massmutual.png',
    },
    {
      value: 'mutualofomahainsurance',
      label: 'Mutual of Omaha Insurance',
      logo: 'https://cdn.signalapis.com/images/carriers/mutual_of_omaha.png',
    },
    {
      value: 'nationallifegroup',
      label: 'National Life Group',
      logo: 'https://cdn.signalapis.com/images/carriers/national_life_group.png',
    },
    {
      value: 'nationalwesternlife',
      label: 'National Western Life',
      logo: 'http://cdn.signalapis.com/images/carriers/national_western_life.png',
    },
    {
      value: 'nationwide',
      label: 'Nationwide',
      logo: 'https://cdn.signalapis.com/images/carriers/nationwide.png',
    },
    {
      value: 'northamerican',
      label: 'North American',
      logo: 'https://cdn.signalapis.com/images/carriers/sammons_financial.png',
    },
    {
      value: 'oneamericafinancialpartners',
      label: 'OneAmerica Financial Partners',
      logo: 'http://cdn.signalapis.com/images/carriers/one_america.png',
    },
    {
      value: 'pacificlife',
      label: 'Pacific Life',
      logo: 'https://cdn.signalapis.com/images/carriers/pacific_life.png',
    },
    {
      value: 'principalfinancial',
      label: 'Principal Financial',
      logo: 'http://cdn.signalapis.com/images/carriers/principal_financial.png',
    },
    {
      value: 'protectivelife',
      label: 'Protective Life',
      logo: 'https://cdn.signalapis.com/images/carriers/protective_life.png',
    },
    {
      value: 'prudential',
      label: 'Prudential',
      logo: 'https://cdn.signalapis.com/images/carriers/prudential.png',
    },
    {
      value: 'samba',
      label: 'Samba',
      logo: 'https://www.sambaplans.com/wp-content/uploads/logo.png',
    },
    {
      value: 'securianfinancial',
      label: 'Securian Financial',
      logo: 'https://cdn.signalapis.com/images/carriers/securian.png',
    },
    {
      value: 'southernwestern',
      label: 'Southern Western',
      logo: 'https://southwestern.com/wp-content/uploads/2019/06/SW-Insurance-Company-Overview-logo.png',
    },
    {
      value: 'statefarm',
      label: 'State Farm',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/9/9a/State_Farm_logo.svg',
    },
    {
      value: 'symetra',
      label: 'Symetra',
      logo: 'https://cdn.signalapis.com/images/carriers/symetra.png',
    },
    {
      value: 'transamerica',
      label: 'TransAmerica',
      logo: 'https://cdn.signalapis.com/images/carriers/transamerica.png',
    },
    {
      value: 'usaa',
      label: 'USAA',
      logo: 'https://insurifycdn.com/images/carrier/high-definition/usaa.svg',
    },
    { value: 'other', label: 'Other', logo: '' },
  ],
  privateLifeInsuranceTypes: [
    { value: 'termlife', label: 'Term Life' },
    {
      value: 'gul_(guaranteed_universal_life)',
      label: 'GUL (Guaranteed Universal Life)',
    },
    {
      value: 'giul_(guaranteed_indexed_universal_life)',
      label: 'GIUL (Guaranteed Indexed Universal Life)',
    },
    {
      value: 'iul_(indexed_universal_life)',
      label: 'IUL (Indexed Universal Life)',
    },
    {
      value: 'vul_(variable_universal_life)',
      label: 'VUL (Variable Universal Life)',
    },
    { value: 'whole_life', label: 'Whole Life' },
  ],
  agency: [
    {
      value: 'abilityone_commission',
      label: 'AbilityOne Commission',
      shortcode: 'A1C',
      jobRetention: 0.99,
      logo: 'https://www.abilityone.gov/images/commission_logo.png',
    },
    {
      value: 'access_board',
      label: 'Access Board',
      shortcode: 'Access Board',
      jobRetention: 0.99,
      logo: 'https://www.acf.hhs.gov/sites/default/files/images/acf_icon.png',
    },
    {
      value: 'administration_for_children_and_families_(acf)',
      label: 'Administration for Children and Families (ACF)',
      shortcode: 'ACF',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/24/Administration_for_Children_and_Families_logo.svg',
    },
    {
      value: 'administration_for_community_living',
      label: 'Administration for Community Living',
      shortcode: 'ACL',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/7/7c/Administration_for_Community_Living_logo.svg',
    },
    {
      value: 'administration_for_native_americans',
      label: 'Administration for Native Americans',
      shortcode: 'ANA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'administrative_conference_of_the_united_states',
      label: 'Administrative Conference of the United States',
      shortcode: 'ACUS',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/fb/Seal_of_the_Administrative_Conference_of_the_United_States.png',
    },
    {
      value: 'administrative_office_of_the_u.s._courts',
      label: 'Administrative Office of the U.S. Courts',
      shortcode: 'AOUSC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'advisory_council_on_historic_preservation',
      label: 'Advisory Council on Historic Preservation',
      shortcode: 'ACHP',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'african_development_foundation',
      label: 'African Development Foundation',
      shortcode: 'ADF',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/9/91/African_Development_Foundation_logo.svg',
    },
    {
      value: 'agency_for_global_media',
      label: 'Agency for Global Media',
      shortcode: 'AGM',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/Logo_of_the_U.S._Agency_for_Global_Media.svg',
    },
    {
      value: 'agency_for_healthcare_research_and_quality_(ahrq)',
      label: 'Agency for Healthcare Research and Quality (AHRQ)',
      shortcode: 'AHRQ',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'agency_for_toxic_substances_and_disease_registry',
      label: 'Agency for Toxic Substances and Disease Registry',
      shortcode: 'ATSDR',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'agricultural_marketing_service_(ams)',
      label: 'Agricultural Marketing Service (AMS)',
      shortcode: 'AMS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'agricultural_research_service',
      label: 'Agricultural Research Service',
      shortcode: 'ARS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'agriculture_library',
      label: 'Agriculture Library',
      shortcode: 'Agriculture Library',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'air_force_reserve',
      label: 'Air Force Reserve',
      shortcode: 'AFR',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/d/d4/US_Air_Force_Reserve_Badge.png',
    },
    {
      value: 'alcohol_and_tobacco_tax_and_trade_bureau',
      label: 'Alcohol and Tobacco Tax and Trade Bureau',
      shortcode: 'TTB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'alcohol_tobacco_firearms_and_explosives_bureau_(atf)',
      label: 'Alcohol Tobacco Firearms and Explosives Bureau (ATF)',
      shortcode: 'ATF',
      jobRetention: 0.99,
      logo: 'https://www.atf.gov/sites/all/themes/custom/atf/images/atf-logo.png',
    },
    {
      value: 'alhurra_tv',
      label: 'Alhurra TV',
      shortcode: 'Alhurra',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'american_battle_monuments_commission',
      label: 'American Battle Monuments Commission',
      shortcode: 'ABMC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'americorps',
      label: 'AmeriCorps',
      shortcode: 'AmeriCorps',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'amtrak_(amtrak)',
      label: 'Amtrak (AMTRAK)',
      shortcode: 'AMTRAK',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'animal_and_plant_health_inspection_service_(aphis)',
      label: 'Animal and Plant Health Inspection Service (APHIS)',
      shortcode: 'APHIS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'antitrust_division',
      label: 'Antitrust Division',
      shortcode: 'Antitrust Division',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'appalachian_regional_commission',
      label: 'Appalachian Regional Commission',
      shortcode: 'ARC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'architect_of_the_capitol',
      label: 'Architect of the Capitol',
      shortcode: 'AOC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'armed_forces_retirement_home',
      label: 'Armed Forces Retirement Home',
      shortcode: 'AFRH',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'arms_control_and_international_security',
      label: 'Arms Control and International Security',
      shortcode: 'Arms Control and International Security',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'army_corps_of_engineers',
      label: 'Army Corps of Engineers',
      shortcode: 'USACE',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/3/35/United_States_Army_Corps_of_Engineers_logo.svg',
    },
    {
      value: 'bankruptcy_courts',
      label: 'Bankruptcy Courts',
      shortcode: 'Bankruptcy Courts',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value:
        'barry_m._goldwater_scholarship_and_excellence_in_education_program',
      label:
        'Barry M. Goldwater Scholarship and Excellence in Education Program',
      shortcode:
        'Barry M. Goldwater Scholarship and Excellence in Education Program',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'bonneville_power_administration',
      label: 'Bonneville Power Administration',
      shortcode: 'BPA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/en/0/0d/Bonneville_Power_Administration_%28logo%2C_2015%29.svg',
    },
    {
      value: 'bureau_of_consular_affairs',
      label: 'Bureau of Consular Affairs',
      shortcode: 'Bureau of Consular Affairs',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'bureau_of_economic_analysis_(bea)',
      label: 'Bureau of Economic Analysis (BEA)',
      shortcode: 'BEA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'bureau_of_engraving_and_printing_(bep)',
      label: 'Bureau of Engraving and Printing (BEP)',
      shortcode: 'BEP',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'bureau_of_indian_affairs',
      label: 'Bureau of Indian Affairs',
      shortcode: 'BIA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'bureau_of_industry_and_security_(bis)',
      label: 'Bureau of Industry and Security (BIS)',
      shortcode: 'BIS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'bureau_of_international_labor_affairs',
      label: 'Bureau of International Labor Affairs',
      shortcode: 'ILAB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'bureau_of_justice_statistics',
      label: 'Bureau of Justice Statistics',
      shortcode: 'BJS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'bureau_of_labor_statistics',
      label: 'Bureau of Labor Statistics',
      shortcode: 'BLS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'bureau_of_land_management_(blm)',
      label: 'Bureau of Land Management (BLM)',
      shortcode: 'BLM',
      jobRetention: 0.99,
      logo: 'https://www.blm.gov/themes/custom/blm_d9_22/logo.svg',
    },
    {
      value: 'bureau_of_ocean_energy_management',
      label: 'Bureau of Ocean Energy Management',
      shortcode: 'BOEM',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'bureau_of_reclamation',
      label: 'Bureau of Reclamation',
      shortcode: 'USBR',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/c/ca/USBR_logo_oct_2019.jpg',
    },
    {
      value: 'bureau_of_safety_and_environmental_enforcement_(bsee)',
      label: 'Bureau of Safety and Environmental Enforcement (BSEE)',
      shortcode: 'BSEE',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/8/84/BSEEseal_2023.png',
    },
    {
      value: 'bureau_of_the_fiscal_service',
      label: 'Bureau of the Fiscal Service',
      shortcode: 'BFS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'bureau_of_transportation_statistics',
      label: 'Bureau of Transportation Statistics',
      shortcode: 'BTS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'capitol_visitor_center',
      label: 'Capitol Visitor Center',
      shortcode: 'CVC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'center_for_food_safety_and_applied_nutrition',
      label: 'Center for Food Safety and Applied Nutrition',
      shortcode: 'CFSAN',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'center_for_nutrition_policy_and_promotion_(cnpp)',
      label: 'Center for Nutrition Policy and Promotion (CNPP)',
      shortcode: 'CNPP',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'center_for_parent_information_and_resources_(cpir)',
      label: 'Center for Parent Information and Resources (CPIR)',
      shortcode: 'CPIR',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'centers_for_disease_control_and_prevention_(cdc)',
      label: 'Centers for Disease Control and Prevention (CDC)',
      shortcode: 'CDC',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/7/71/US_CDC_logo.svg',
    },
    {
      value: 'centers_for_medicare_and_medicaid_services_(cms)',
      label: 'Centers for Medicare and Medicaid Services (CMS)',
      shortcode: 'CMS',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2a/Centers_for_Medicare_and_Medicaid_Services_logo.svg',
    },
    {
      value: 'central_intelligence_agency_(cia)',
      label: 'Central Intelligence Agency (CIA)',
      shortcode: 'CIA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/25/Seal_of_the_Central_Intelligence_Agency.svg',
    },
    {
      value: 'chief_acquisition_officers_council',
      label: 'Chief Acquisition Officers Council',
      shortcode: 'CAOC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'chief_financial_officers_council',
      label: 'Chief Financial Officers Council',
      shortcode: 'CFOC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'chief_human_capital_officers_council',
      label: 'Chief Human Capital Officers Council',
      shortcode: 'CHCOC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'chief_information_officers_council',
      label: 'Chief Information Officers Council',
      shortcode: 'CIOC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'circuit_courts_of_appeal',
      label: 'Circuit Courts of Appeal',
      shortcode: 'N/A (usually referred by circuit - e.g. First Circuit)',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'citizens_stamp_advisory_committee',
      label: 'Citizens Stamp Advisory Committee',
      shortcode: 'CSAC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'citizenship_and_immigration_services_(uscis)',
      label: 'Citizenship and Immigration Services (USCIS)',
      shortcode: 'USCIS',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a3/USCIS_logo_English.svg',
    },
    {
      value: 'civil_rights_division_-_department_of_justice',
      label: 'Civil Rights Division - Department of Justice',
      shortcode: 'CRT',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/5/54/Seal_of_the_United_States_Department_of_Justice.svg',
    },
    {
      value: 'commission_on_civil_rights',
      label: 'Commission on Civil Rights',
      shortcode: 'USCCR',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'commission_on_presidential_scholars',
      label: 'Commission on Presidential Scholars',
      shortcode: 'Commission on Presidential Scholars',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value:
        'commission_on_security_and_cooperation_in_europe_(helsinki_commission)',
      label:
        'Commission on Security and Cooperation in Europe (Helsinki Commission)',
      shortcode: 'USCE',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'committee_for_the_implementation_of_textile_agreements',
      label: 'Committee for the Implementation of Textile Agreements',
      shortcode: 'CITA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'committee_on_foreign_investment_in_the_united_states',
      label: 'Committee on Foreign Investment in the United States',
      shortcode: 'CFIUS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'commodity_futures_trading_commission_(cftc)',
      label: 'Commodity Futures Trading Commission (CFTC)',
      shortcode: 'CFTC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'community_oriented_policing_services_(cops)',
      label: 'Community Oriented Policing Services (COPS)',
      shortcode: 'COPS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'community_planning_and_development',
      label: 'Community Planning and Development',
      shortcode: 'Community Planning and Development',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'computer_emergency_readiness_team_(us_cert)',
      label: 'Computer Emergency Readiness Team (US CERT)',
      shortcode: 'US-CERT',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'congressional_budget_office_(cbo)',
      label: 'Congressional Budget Office (CBO)',
      shortcode: 'CBO',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'congressional_research_service',
      label: 'Congressional Research Service',
      shortcode: 'CRS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'consumer_financial_protection_bureau',
      label: 'Consumer Financial Protection Bureau',
      shortcode: 'CFPB',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/9/9d/Seal_of_the_Consumer_Financial_Protection_Bureau.svg',
    },
    {
      value: 'consumer_product_safety_commission_(cpsc)',
      label: 'Consumer Product Safety Commission (CPSC)',
      shortcode: 'CPSC',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/fb/CPSC_Logo.svg',
    },
    {
      value:
        'coordinating_council_on_juvenile_justice_and_delinquency_prevention',
      label:
        'Coordinating Council on Juvenile Justice and Delinquency Prevention',
      shortcode:
        'Coordinating Council on Juvenile Justice and Delinquency Prevention',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'copyright_office',
      label: 'Copyright Office',
      shortcode: 'Copyright Office',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'corporation_for_national_and_community_service_(cncs)',
      label: 'Corporation for National and Community Service (CNCS)',
      shortcode: 'CNCS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'council_of_economic_advisers',
      label: 'Council of Economic Advisers',
      shortcode: 'CEA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'council_of_the_inspectors_general_on_integrity_and_efficiency',
      label: 'Council of the Inspectors General on Integrity and Efficiency',
      shortcode: 'CIGIE',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'council_on_environmental_quality',
      label: 'Council on Environmental Quality',
      shortcode: 'CEQ',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'court_of_appeals_for_the_armed_forces',
      label: 'Court of Appeals for the Armed Forces',
      shortcode: 'CAAF',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'court_of_appeals_for_the_federal_circuit',
      label: 'Court of Appeals for the Federal Circuit',
      shortcode: 'CAF',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'court_of_appeals_for_veterans_claims',
      label: 'Court of Appeals for Veterans Claims',
      shortcode: 'CAVC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'court_of_federal_claims',
      label: 'Court of Federal Claims',
      shortcode: 'CFC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'court_of_international_trade',
      label: 'Court of International Trade',
      shortcode: 'CIT',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value:
        'court_services_and_offender_supervision_agency_for_the_district_of_columbia',
      label:
        'Court Services and Offender Supervision Agency for the District of Columbia',
      shortcode: 'CSOSA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'customs_and_border_protection',
      label: 'Customs and Border Protection',
      shortcode: 'CBP',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/0/08/Seal_of_U.S._Customs_and_Border_Protection.png',
    },
    {
      value: 'cybersecurity_and_infrastructure_security_agency_(cisa)',
      label: 'Cybersecurity and Infrastructure Security Agency (CISA)',
      shortcode: 'CISA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'debt_and_claims_management_center',
      label: 'Debt and Claims Management Center',
      shortcode: 'Debt and Claims Management Center',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'defense_advanced_research_projects_agency_(darpa)',
      label: 'Defense Advanced Research Projects Agency (DARPA)',
      shortcode: 'DARPA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'defense_commissary_agency',
      label: 'Defense Commissary Agency',
      shortcode: 'DeCA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'defense_commissary_agency_(dca)',
      label: 'Defense Commissary Agency (DCA)',
      shortcode: 'DCA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'defense_contract_audit_agency',
      label: 'Defense Contract Audit Agency',
      shortcode: 'DCAA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f3/Defense_Contract_Audit_Agency_seal.svg',
    },
    {
      value: 'defense_contract_management_agency',
      label: 'Defense Contract Management Agency',
      shortcode: 'DCMA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c0/Seal_of_the_Defense_Contract_Management_Agency.svg',
    },
    {
      value: 'defense_finance_and_accounting_service_(dfas)',
      label: 'Defense Finance and Accounting Service (DFAS)',
      shortcode: 'DFAS',
      jobRetention: 0.99,
      logo: 'https://www.dfas.mil/Portals/98/dfas_logo_small.png',
    },
    {
      value:
        'defense_finance_and_accounting_service_debt_and_claims_management_center',
      label:
        'Defense Finance and Accounting Service Debt and Claims Management Center',
      shortcode:
        'Defense Finance and Accounting Service Debt and Claims Management Center',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'defense_health_agency_(dha)',
      label: 'Defense Health Agency (DHA)',
      shortcode: 'DHA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/6/69/Seal_of_Defense_Health_Agency.svg',
    },
    {
      value: 'defense_information_systems_agency_(disa)',
      label: 'Defense Information Systems Agency (DISA)',
      shortcode: 'DISA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/DISA_Seal.png/250px-DISA_Seal.png',
    },
    {
      value: 'defense_intelligence_agency_(dia)',
      label: 'Defense Intelligence Agency (DIA)',
      shortcode: 'DIA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/5/56/Seal_of_the_U.S._Defense_Intelligence_Agency.svg',
    },
    {
      value: 'defense_logistics_agency_(dla)',
      label: 'Defense Logistics Agency (DLA)',
      shortcode: 'DLA',
      jobRetention: 0.99,
      logo: 'https://www.dla.mil/Portals/104/DLAEmblemWebsiteHeader.png',
    },
    {
      value: 'defense_nuclear_facilities_safety_board',
      label: 'Defense Nuclear Facilities Safety Board',
      shortcode: 'DNFSB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'defense_security_cooperation_agency_(dsca)',
      label: 'Defense Security Cooperation Agency (DSCA)',
      shortcode: 'DSCA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'defense_security_service',
      label: 'Defense Security Service',
      shortcode: 'DSS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'defense_technical_information_center_(dtic)',
      label: 'Defense Technical Information Center (DTIC)',
      shortcode: 'DTIC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'defense_threat_reduction_agency_(dtra)',
      label: 'Defense Threat Reduction Agency (DTRA)',
      shortcode: 'DTRA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'delaware_river_basin_commission',
      label: 'Delaware River Basin Commission',
      shortcode: 'DRBC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'delta_regional_authority',
      label: 'Delta Regional Authority',
      shortcode: 'DRA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'denali_commission',
      label: 'Denali Commission',
      shortcode: 'Denali Commission',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'department_of_agriculture_(usda)',
      label: 'Department of Agriculture (USDA)',
      shortcode: 'USDA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/0/04/Logo_of_the_United_States_Department_of_Agriculture.svg',
    },
    {
      value: 'department_of_commerce_(doc)',
      label: 'Department of Commerce (DOC)',
      shortcode: 'DOC',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1a/Seal_of_the_United_States_Department_of_Commerce.svg',
    },
    {
      value: 'department_of_defense_(dod)',
      label: 'Department of Defense (DOD)',
      shortcode: 'DOD',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2e/Seal_of_the_United_States_Department_of_Defense.svg',
    },
    {
      value: 'department_of_education_(ed)',
      label: 'Department of Education (ED)',
      shortcode: 'ED',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/a/ad/Seal_of_the_United_States_Department_of_Education.svg',
    },
    {
      value: 'department_of_education_office_of_civil_rights',
      label: 'Department of Education Office of Civil Rights',
      shortcode: 'EDOCR',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'department_of_energy_(doe)',
      label: 'Department of Energy (DOE)',
      shortcode: 'DOE',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0b/Seal_of_the_Department_of_Energy.svg',
    },
    {
      value: 'department_of_health_and_human_services_(hhs)',
      label: 'Department of Health and Human Services (HHS)',
      shortcode: 'HHS',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b7/US_Department_of_Health_and_Human_Services_seal.svg',
    },
    {
      value: 'department_of_health_and_human_services_office_for_civil_rights',
      label: 'Department of Health and Human Services Office for Civil Rights',
      shortcode: 'HHSOCR',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'department_of_homeland_security_(dhs)',
      label: 'Department of Homeland Security (DHS)',
      shortcode: 'DHS',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/8/81/Seal_of_the_U.S._Department_of_Homeland_Security.svg',
    },
    {
      value: 'department_of_housing_and_urban_development_(hud)',
      label: 'Department of Housing and Urban Development (HUD)',
      shortcode: 'HUD',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2e/Seal_of_the_United_States_Department_of_Housing_and_Urban_Development.svg',
    },
    {
      value: 'department_of_justice_(doj)',
      label: 'Department of Justice (DOJ)',
      shortcode: 'DOJ',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/5/54/Seal_of_the_United_States_Department_of_Justice.svg',
    },
    {
      value: 'department_of_labor_(dol)',
      label: 'Department of Labor (DOL)',
      shortcode: 'DOL',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c1/Seal_of_the_United_States_Department_of_Labor.svg',
    },
    {
      value: 'department_of_state_(dos)',
      label: 'Department of State (DOS)',
      shortcode: 'DOS',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/7/7b/Seal_of_the_United_States_Department_of_State.svg',
    },
    {
      value: 'department_of_the_interior_(doi)',
      label: 'Department of the Interior (DOI)',
      shortcode: 'DOI',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/e/ea/Seal_of_the_United_States_Department_of_the_Interior.svg',
    },
    {
      value: 'department_of_the_treasury',
      label: 'Department of the Treasury',
      shortcode: 'Treasury',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/c/cb/Seal_of_the_United_States_Department_of_the_Treasury.svg',
    },
    {
      value: 'department_of_transportation_(dot)',
      label: 'Department of Transportation (DOT)',
      shortcode: 'DOT',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/3/34/Seal_of_the_United_States_Department_of_Transportation_-_Alternate_Version.svg',
    },
    {
      value: 'department_of_veterans_affairs_(va)',
      label: 'Department of Veterans Affairs (VA)',
      shortcode: 'VA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/0/05/Seal_of_the_U.S._Department_of_Veterans_Affairs.svg',
    },
    {
      value: 'drug_enforcement_administration_(dea)',
      label: 'Drug Enforcement Administration (DEA)',
      shortcode: 'DEA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/4/41/Seal_of_the_United_States_Drug_Enforcement_Administration.svg',
    },
    {
      value:
        'dwight_d._eisenhower_school_for_national_security_and_resource_strategy',
      label:
        'Dwight D. Eisenhower School for National Security and Resource Strategy',
      shortcode: 'ES',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'economic_development_administration_(eda)',
      label: 'Economic Development Administration (EDA)',
      shortcode: 'EDA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'economic_growth_energy_and_the_environment',
      label: 'Economic Growth Energy and the Environment',
      shortcode: 'Economic Growth Energy and the Environment',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'economic_research_service',
      label: 'Economic Research Service',
      shortcode: 'ERS',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f6/US-EconomicResearchService-Logo.svg',
    },
    {
      value: 'elder_justice_initiative',
      label: 'Elder Justice Initiative',
      shortcode: 'Elder Justice Initiative',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'election_assistance_commission_(eac)',
      label: 'Election Assistance Commission (EAC)',
      shortcode: 'EAC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'employee_benefits_security_administration_(ebsa)',
      label: 'Employee Benefits Security Administration (EBSA)',
      shortcode: 'EBSA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'employment_and_training_administration',
      label: 'Employment and Training Administration',
      shortcode: 'ETA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'endangered_species_program',
      label: 'Endangered Species Program',
      shortcode: 'Endangered Species Program',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'energy_information_administration',
      label: 'Energy Information Administration',
      shortcode: 'EIA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'energy_star_program',
      label: 'Energy Star Program',
      shortcode: 'Energy Star Program',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'english_language_acquisition_office',
      label: 'English Language Acquisition Office',
      shortcode: 'English Language Acquisition Office',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'environmental_protection_agency_(epa)',
      label: 'Environmental Protection Agency (EPA)',
      shortcode: 'EPA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/6/6f/Seal_of_the_United_States_Environmental_Protection_Agency.svg',
    },
    {
      value: 'equal_employment_opportunity_commission_(eeoc)',
      label: 'Equal Employment Opportunity Commission (EEOC)',
      shortcode: 'EEOC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'executive_office_for_immigration_review',
      label: 'Executive Office for Immigration Review',
      shortcode: 'EOIR',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'export-import_bank_of_the_united_states',
      label: 'Export-Import Bank of the United States',
      shortcode: 'EXIM',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'fannie_mae',
      label: 'Fannie Mae',
      shortcode: 'Fannie Mae',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'farm_credit_administration',
      label: 'Farm Credit Administration',
      shortcode: 'FCA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'farm_credit_system_insurance_corporation',
      label: 'Farm Credit System Insurance Corporation',
      shortcode: 'FCSIC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'farm_service_agency',
      label: 'Farm Service Agency',
      shortcode: 'FSA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/4/47/US-FarmServiceAgency-2008Logo.svg',
    },
    {
      value: 'federal_accounting_standards_advisory_board',
      label: 'Federal Accounting Standards Advisory Board',
      shortcode: 'FASAB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_aviation_administration_(faa)',
      label: 'Federal Aviation Administration (FAA)',
      shortcode: 'FAA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c8/Seal_of_the_United_States_Federal_Aviation_Administration.svg',
    },
    {
      value: 'federal_bureau_of_investigation_(fbi)',
      label: 'Federal Bureau of Investigation (FBI)',
      shortcode: 'FBI',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/5/59/Seal_of_the_FBI.svg',
    },
    {
      value: 'federal_bureau_of_prisons_(bop)',
      label: 'Federal Bureau of Prisons (BOP)',
      shortcode: 'BOP',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c7/Seal_of_the_Federal_Bureau_of_Prisons.svg',
    },
    {
      value: 'federal_citizen_information_center',
      label: 'Federal Citizen Information Center',
      shortcode: 'Federal Citizen Information Center',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_communications_commission_(fcc)',
      label: 'Federal Communications Commission (FCC)',
      shortcode: 'FCC',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/23/Seal_of_the_Federal_Communications_Commission.svg',
    },
    {
      value: 'federal_consulting_group',
      label: 'Federal Consulting Group',
      shortcode: 'Federal Consulting Group',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_court_interpreters',
      label: 'Federal Court Interpreters',
      shortcode: 'Federal Court Interpreters',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_deposit_insurance_corporation_(fdic)',
      label: 'Federal Deposit Insurance Corporation (FDIC)',
      shortcode: 'FDIC',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/b/bd/Seal_of_the_United_States_Federal_Deposit_Insurance_Corporation.svg',
    },
    {
      value: 'federal_election_commission',
      label: 'Federal Election Commission',
      shortcode: 'FEC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_emergency_management_agency_(fema)',
      label: 'Federal Emergency Management Agency (FEMA)',
      shortcode: 'FEMA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/c/ca/Seal_of_the_Federal_Emergency_Management_Agency.svg',
    },
    {
      value: 'federal_energy_regulatory_commission',
      label: 'Federal Energy Regulatory Commission',
      shortcode: 'FERC',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0d/Seal_of_the_United_States_Federal_Energy_Regulatory_Commission.svg',
    },
    {
      value: 'federal_executive_boards',
      label: 'Federal Executive Boards',
      shortcode: 'FEBs',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_financial_institutions_examination_council',
      label: 'Federal Financial Institutions Examination Council',
      shortcode: 'FFIEC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_financing_bank',
      label: 'Federal Financing Bank',
      shortcode: 'FFB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_geographic_data_committee',
      label: 'Federal Geographic Data Committee',
      shortcode: 'FGDC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_highway_administration_(fha)',
      label: 'Federal Highway Administration (FHA)',
      shortcode: 'FHWA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_home_loan_mortgage_corporation_(freddie_mac)',
      label: 'Federal Home Loan Mortgage Corporation (Freddie Mac)',
      shortcode: 'FHLMC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_housing_administration_(fha)',
      label: 'Federal Housing Administration (FHA)',
      shortcode: 'FHA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_housing_finance_agency',
      label: 'Federal Housing Finance Agency',
      shortcode: 'FHFA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_interagency_committee_on_education',
      label: 'Federal Interagency Committee on Education',
      shortcode: 'FICE',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_interagency_council_on_statistical_policy',
      label: 'Federal Interagency Council on Statistical Policy',
      shortcode: 'FICSP',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_judicial_center',
      label: 'Federal Judicial Center',
      shortcode: 'FJC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_labor_relations_authority_(flra)',
      label: 'Federal Labor Relations Authority (FLRA)',
      shortcode: 'FLRA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_laboratory_consortium_for_technology_transfer',
      label: 'Federal Laboratory Consortium for Technology Transfer',
      shortcode: 'FLC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_law_enforcement_training_center_(fletc)',
      label: 'Federal Law Enforcement Training Center (FLETC)',
      shortcode: 'FLETC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_library_and_information_center_committee',
      label: 'Federal Library and Information Center Committee',
      shortcode: 'FLICC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_maritime_commission',
      label: 'Federal Maritime Commission',
      shortcode: 'FMC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_mediation_and_conciliation_service',
      label: 'Federal Mediation and Conciliation Service',
      shortcode: 'FMCS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_mine_safety_and_health_review_commission',
      label: 'Federal Mine Safety and Health Review Commission',
      shortcode: 'FMSHRC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_motor_carrier_safety_administration_(fmcsa)',
      label: 'Federal Motor Carrier Safety Administration (FMCSA)',
      shortcode: 'FMCSA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_national_mortgage_association_(fannie_mae)',
      label: 'Federal National Mortgage Association (Fannie Mae)',
      shortcode: 'FNMA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_protective_service',
      label: 'Federal Protective Service',
      shortcode: 'FPS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_railroad_administration_(fra)',
      label: 'Federal Railroad Administration (FRA)',
      shortcode: 'FRA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_register',
      label: 'Federal Register',
      shortcode: 'FR',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_reserve_system',
      label: 'Federal Reserve System',
      shortcode: 'FRB',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1a/Seal_of_the_United_States_Federal_Reserve_System.svg',
    },
    {
      value: 'federal_retirement_thrift_investment_board',
      label: 'Federal Retirement Thrift Investment Board',
      shortcode: 'FRTIB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_student_aid_information_center',
      label: 'Federal Student Aid Information Center',
      shortcode: 'FSAIC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_trade_commission_(ftc)',
      label: 'Federal Trade Commission (FTC)',
      shortcode: 'FTC',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b0/FTC_logo_-_blue.svg',
    },
    {
      value: 'federal_transit_administration_(fta)',
      label: 'Federal Transit Administration (FTA)',
      shortcode: 'FTA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'federal_voting_assistance_program',
      label: 'Federal Voting Assistance Program',
      shortcode: 'FVAP',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'fedstats',
      label: 'FedStats',
      shortcode: 'FedStats',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'fish_and_wildlife_service_(fws)',
      label: 'Fish and Wildlife Service (FWS)',
      shortcode: 'FWS',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/4/40/Seal_of_the_United_States_Fish_and_Wildlife_Service.svg',
    },
    {
      value: 'food_and_drug_administration_(fda)',
      label: 'Food and Drug Administration (FDA)',
      shortcode: 'FDA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1d/Food_and_Drug_Administration_icon_2016.svg',
    },
    {
      value: 'food_and_nutrition_service',
      label: 'Food and Nutrition Service',
      shortcode: 'FNS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'food_safety_and_inspection_service',
      label: 'Food Safety and Inspection Service',
      shortcode: 'FSIS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'foreign_agricultural_service',
      label: 'Foreign Agricultural Service',
      shortcode: 'FAS',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c5/US-ForeignAgriculturalService-Logo.svg',
    },
    {
      value: 'foreign_claims_settlement_commission',
      label: 'Foreign Claims Settlement Commission',
      shortcode: 'FCSC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'forest_service',
      label: 'Forest Service',
      shortcode: 'USFS',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/d/d0/Logo_of_the_United_States_Forest_Service.svg',
    },
    {
      value: 'freddie_mac',
      label: 'Freddie Mac',
      shortcode: 'Freddie Mac',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'fulbright_foreign_scholarship_board',
      label: 'Fulbright Foreign Scholarship Board',
      shortcode: 'FFSB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'general_services_administration_(gsa)',
      label: 'General Services Administration (GSA)',
      shortcode: 'GSA',
      jobRetention: 0.99,
      logo: 'https://www.gsa.gov/sites/gsa.gov/themes/custom/gsa/logo.png',
    },
    {
      value: 'government_accountability_office_(gao)',
      label: 'Government Accountability Office (GAO)',
      shortcode: 'GAO',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'government_national_mortgage_association_(ginnie_mae)',
      label: 'Government National Mortgage Association (Ginnie Mae)',
      shortcode: 'GNMA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'government_publishing_office_(gpo)',
      label: 'Government Publishing Office (GPO)',
      shortcode: 'GPO',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'grain_inspection_packers_and_stockyards_administration',
      label: 'Grain Inspection Packers and Stockyards Administration',
      shortcode: 'GIPSA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'harry_s._truman_scholarship_foundation',
      label: 'Harry S. Truman Scholarship Foundation',
      shortcode: 'HSTSF',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'health_resources_and_services_administration',
      label: 'Health Resources and Services Administration',
      shortcode: 'HRSA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'helsinki_commission',
      label: 'Helsinki Commission',
      shortcode: 'CSCE',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'holocaust_memorial_museum',
      label: 'Holocaust Memorial Museum',
      shortcode: 'USHMM',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'hour_and_wage_division_(whd)',
      label: 'Hour and Wage Division (WHD)',
      shortcode: 'WHD',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'house_of_representatives',
      label: 'House of Representatives',
      shortcode: 'House of Representatives',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'house_office_of_inspector_general',
      label: 'House Office of Inspector General',
      shortcode: 'HOIG',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'house_office_of_the_clerk',
      label: 'House Office of the Clerk',
      shortcode: 'House Office of the Clerk',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'housing_office',
      label: 'Housing Office',
      shortcode: 'Housing Office',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2e/Seal_of_the_United_States_Department_of_Housing_and_Urban_Development.svg',
    },
    {
      value: 'immigration_and_customs_enforcement_(ice)',
      label: 'Immigration and Customs Enforcement (ICE)',
      shortcode: 'ICE',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/8/81/Seal_of_the_U.S._Department_of_Homeland_Security.svg',
    },
    {
      value: 'indian_arts_and_crafts_board',
      label: 'Indian Arts and Crafts Board',
      shortcode: 'IACB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'indian_health_service',
      label: 'Indian Health Service',
      shortcode: 'IHS',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/7/73/Indian_Health_Service_Logo.svg',
    },
    {
      value: 'indoor_air_quality_(iaq)',
      label: 'Indoor Air Quality (IAQ)',
      shortcode: 'IAQ',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'industrial_college_of_the_armed_forces',
      label: 'Industrial College of the Armed Forces',
      shortcode: 'ICAF',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'information_resource_management_college',
      label: 'Information Resource Management College',
      shortcode: 'IRMC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'innovation_and_improvement_office',
      label: 'Innovation and Improvement Office',
      shortcode: 'OII',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'inspectors_general',
      label: 'Inspectors General',
      shortcode: 'IGs',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'institute_of_education_sciences',
      label: 'Institute of Education Sciences',
      shortcode: 'IES',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'institute_of_museum_and_library_services',
      label: 'Institute of Museum and Library Services',
      shortcode: 'IMLS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'institute_of_peace',
      label: 'Institute of Peace',
      shortcode: 'USIP',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'interagency_alternative_dispute_resolution_working_group',
      label: 'Interagency Alternative Dispute Resolution Working Group',
      shortcode: 'Interagency Alternative Dispute Resolution Working Group',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value:
        'interagency_committee_for_the_management_of_noxious_and_exotic_weeds',
      label:
        'Interagency Committee for the Management of Noxious and Exotic Weeds',
      shortcode:
        'Interagency Committee for the Management of Noxious and Exotic Weeds',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'interagency_council_on_homelessness',
      label: 'Interagency Council on Homelessness',
      shortcode: 'USICH',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'inter-american_foundation',
      label: 'Inter-American Foundation',
      shortcode: 'IAF',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'internal_revenue_service_(irs)',
      label: 'Internal Revenue Service (IRS)',
      shortcode: 'IRS',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0e/Internal_Revenue_Service_logo.svg',
    },
    {
      value: 'international_trade_administration_(ita)',
      label: 'International Trade Administration (ITA)',
      shortcode: 'ITA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'international_trade_commission',
      label: 'International Trade Commission',
      shortcode: 'ITC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'interpol',
      label: 'Interpol',
      shortcode: 'Interpol',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'james_madison_memorial_fellowship_foundation',
      label: 'James Madison Memorial Fellowship Foundation',
      shortcode: 'JMMFF',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'japan-united_states_friendship_commission',
      label: 'Japan-United States Friendship Commission',
      shortcode: 'JUSFC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'job_corps',
      label: 'Job Corps',
      shortcode: 'Job Corps',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'john_f._kennedy_center_for_the_performing_arts',
      label: 'John F. Kennedy Center for the Performing Arts',
      shortcode: 'JFKC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'joint_board_for_the_enrollment_of_actuaries',
      label: 'Joint Board for the Enrollment of Actuaries',
      shortcode: 'JBEA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'joint_chiefs_of_staff',
      label: 'Joint Chiefs of Staff',
      shortcode: 'JCS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'joint_congressional_committee_on_inaugural_ceremonies',
      label: 'Joint Congressional Committee on Inaugural Ceremonies',
      shortcode: 'JCCIC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'joint_fire_science_program',
      label: 'Joint Fire Science Program',
      shortcode: 'JFSP',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'joint_forces_staff_college',
      label: 'Joint Forces Staff College',
      shortcode: 'JFSC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'joint_military_intelligence_college',
      label: 'Joint Military Intelligence College',
      shortcode: 'JMIC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value:
        'joint_program_executive_office_for_chemical_and_biological_defense',
      label:
        'Joint Program Executive Office for Chemical and Biological Defense',
      shortcode: 'JPEO-CBD',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'judicial_circuit_courts_of_appeal',
      label: 'Judicial Circuit Courts of Appeal',
      shortcode: 'Judicial Circuit Courts of Appeal',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'judicial_panel_on_multidistrict_litigation',
      label: 'Judicial Panel on Multidistrict Litigation',
      shortcode: 'JPML',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'kennedy_center',
      label: 'Kennedy Center',
      shortcode: 'Kennedy Center',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'legal_services_corporation',
      label: 'Legal Services Corporation',
      shortcode: 'LSC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'library_of_congress_(loc)',
      label: 'Library of Congress (LOC)',
      shortcode: 'LOC',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/b/be/Logo_of_the_United_States_Library_of_Congress.svg',
    },
    {
      value: 'marine_corps',
      label: 'Marine Corps',
      shortcode: 'USMC',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/9/90/Seal_of_the_US_Marine_Corps.svg',
    },
    {
      value: 'marine_mammal_commission',
      label: 'Marine Mammal Commission',
      shortcode: 'MMC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'maritime_administration_(marad)',
      label: 'Maritime Administration (MARAD)',
      shortcode: 'MARAD',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'marketing_and_regulatory_programs',
      label: 'Marketing and Regulatory Programs',
      shortcode: 'Marketing and Regulatory Programs',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'marshals_service',
      label: 'Marshals Service',
      shortcode: 'USMS',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/5/50/Seal_of_the_United_States_Marshals_Service.jpg',
    },
    {
      value: 'medicaid_and_chip_payment_and_access_commission',
      label: 'Medicaid and CHIP Payment and Access Commission',
      shortcode: 'MACPAC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'medicare_payment_advisory_commission',
      label: 'Medicare Payment Advisory Commission',
      shortcode: 'MedPAC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'merit_systems_protection_board',
      label: 'Merit Systems Protection Board',
      shortcode: 'MSPB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'middle_east_broadcasting_networks',
      label: 'Middle East Broadcasting Networks',
      shortcode: 'MBN',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'migratory_bird_conservation_commission',
      label: 'Migratory Bird Conservation Commission',
      shortcode: 'MBCC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'military_postal_service_agency',
      label: 'Military Postal Service Agency',
      shortcode: 'MPSA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'millennium_challenge_corporation',
      label: 'Millennium Challenge Corporation',
      shortcode: 'MCC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'mine_safety_and_health_administration_(msha)',
      label: 'Mine Safety and Health Administration (MSHA)',
      shortcode: 'MSHA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'minority_business_development_agency',
      label: 'Minority Business Development Agency',
      shortcode: 'MBDA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'mint',
      label: 'Mint',
      shortcode: 'USMint',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'missile_defense_agency_(mda)',
      label: 'Missile Defense Agency (MDA)',
      shortcode: 'MDA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/7/7f/Seal_of_the_U.S._Missile_Defense_Agency.svg',
    },
    {
      value: 'mississippi_river_commission',
      label: 'Mississippi River Commission',
      shortcode: 'MRC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'morris_k._udall_and_stewart_l._udall_foundation',
      label: 'Morris K. Udall and Stewart L. Udall Foundation',
      shortcode: 'Udall Foundation',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'multifamily_housing_office',
      label: 'Multifamily Housing Office',
      shortcode: 'Multifamily Housing Office',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_aeronautics_and_space_administration_(nasa)',
      label: 'National Aeronautics and Space Administration (NASA)',
      shortcode: 'NASA',
      jobRetention: 0.99,
      logo: 'https://www.nasa.gov/wp-content/uploads/2023/04/nasa-logo-web-rgb.png',
    },
    {
      value: 'national_agricultural_statistics_service',
      label: 'National Agricultural Statistics Service',
      shortcode: 'NASS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_archives_and_records_administration_(nara)',
      label: 'National Archives and Records Administration (NARA)',
      shortcode: 'NARA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1f/Seal_of_the_United_States_National_Archives_and_Records_Administration.svg',
    },
    {
      value: 'national_cancer_institute_(nci)',
      label: 'National Cancer Institute (NCI)',
      shortcode: 'NCI',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/7/7e/National_Cancer_Institute_logo.svg',
    },
    {
      value: 'national_capital_planning_commission',
      label: 'National Capital Planning Commission',
      shortcode: 'NCPC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_cemetery_administration',
      label: 'National Cemetery Administration',
      shortcode: 'NCA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_constitution_center',
      label: 'National Constitution Center',
      shortcode: 'NCC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_council_on_disability',
      label: 'National Council on Disability',
      shortcode: 'NCD',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_credit_union_administration_(ncua)',
      label: 'National Credit Union Administration (NCUA)',
      shortcode: 'NCUA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/e/e0/NCUA_official_seal.svg',
    },
    {
      value: 'national_defense_university_(ndu)',
      label: 'National Defense University (NDU)',
      shortcode: 'NDU',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/3/3b/NDU_LOGO.jpg',
    },
    {
      value: 'national_defense_university_icollege',
      label: 'National Defense University iCollege',
      shortcode: 'NDU iCollege',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/College_of_Information_and_Cyberspace_Seal.png/250px-College_of_Information_and_Cyberspace_Seal.png',
    },
    {
      value: 'national_endowment_for_the_arts_(nea)',
      label: 'National Endowment for the Arts (NEA)',
      shortcode: 'NEA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_endowment_for_the_humanities',
      label: 'National Endowment for the Humanities',
      shortcode: 'NEH',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_flood_insurance_program_(nfip)',
      label: 'National Flood Insurance Program (NFIP)',
      shortcode: 'NFIP',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_gallery_of_art',
      label: 'National Gallery of Art',
      shortcode: 'NGA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_geospatial-intelligence_agency_(nga)',
      label: 'National Geospatial-Intelligence Agency (NGA)',
      shortcode: 'NGA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c4/US-NationalGeospatialIntelligenceAgency-OrigSeal.svg',
    },
    {
      value: 'national_guard',
      label: 'National Guard',
      shortcode: 'National Guard',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/28/Seal_of_the_United_States_National_Guard.svg',
    },
    {
      value: 'national_health_information_center_(nhic)',
      label: 'National Health Information Center (NHIC)',
      shortcode: 'NHIC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_heart_lung_and_blood_institute_(nhlbi)',
      label: 'National Heart Lung and Blood Institute (NHLBI)',
      shortcode: 'NHLBI',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_highway_traffic_safety_administration_(nhtsa)',
      label: 'National Highway Traffic Safety Administration (NHTSA)',
      shortcode: 'NHTSA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_indian_gaming_commission',
      label: 'National Indian Gaming Commission',
      shortcode: 'NIGC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value:
        'national_institute_of_arthritis_musculoskeletal_and_skin_diseases',
      label:
        'National Institute of Arthritis Musculoskeletal and Skin Diseases',
      shortcode: 'NIAMS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_institute_of_corrections',
      label: 'National Institute of Corrections',
      shortcode: 'NIC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value:
        'national_institute_of_deafness_and_other_communication_disorders_(nidcd)',
      label:
        'National Institute of Deafness and Other Communication Disorders (NIDCD)',
      shortcode: 'NIDCD',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value:
        'national_institute_of_diabetes_and_digestive_and_kidney_diseases_(niddk)',
      label:
        'National Institute of Diabetes and Digestive and Kidney Diseases (NIDDK)',
      shortcode: 'NIDDK',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_institute_of_food_and_agriculture_(nifa)',
      label: 'National Institute of Food and Agriculture (NIFA)',
      shortcode: 'NIFA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_institute_of_justice',
      label: 'National Institute of Justice',
      shortcode: 'NIJ',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_institute_of_mental_health_(nimh)',
      label: 'National Institute of Mental Health (NIMH)',
      shortcode: 'NIMH',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_institute_of_neurological_disorders_and_stroke_(ninds)',
      label: 'National Institute of Neurological Disorders and Stroke (NINDS)',
      shortcode: 'NINDS',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/NIH_NINDS_Logo.jpg',
    },
    {
      value: 'national_institute_of_occupational_safety_and_health_(niosh)',
      label: 'National Institute of Occupational Safety and Health (NIOSH)',
      shortcode: 'NIOSH',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_institute_of_standards_and_technology_(nist)',
      label: 'National Institute of Standards and Technology (NIST)',
      shortcode: 'NIST',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/e/ee/NIST_logo.svg',
    },
    {
      value: 'national_institutes_of_health_(nih)',
      label: 'National Institutes of Health (NIH)',
      shortcode: 'NIH',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a6/NIH_2013_logo_vertical.svg',
    },
    {
      value: 'national_intelligence_university_(niu)',
      label: 'National Intelligence University (NIU)',
      shortcode: 'NIU',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_interagency_fire_center',
      label: 'National Interagency Fire Center',
      shortcode: 'NIFC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_labor_relations_board_(nlrb)',
      label: 'National Labor Relations Board (NLRB)',
      shortcode: 'NLRB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_laboratories',
      label: 'National Laboratories',
      shortcode: 'National Laboratories',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_library_of_agriculture',
      label: 'National Library of Agriculture',
      shortcode: 'National Library of Agriculture',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_marine_fisheries_service',
      label: 'National Marine Fisheries Service',
      shortcode: 'NMFS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_mediation_board',
      label: 'National Mediation Board',
      shortcode: 'NMB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_nuclear_security_administration',
      label: 'National Nuclear Security Administration',
      shortcode: 'NNSA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_ocean_service',
      label: 'National Ocean Service',
      shortcode: 'NOS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_oceanic_and_atmospheric_administration_(noaa)',
      label: 'National Oceanic and Atmospheric Administration (NOAA)',
      shortcode: 'NOAA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_park_foundation',
      label: 'National Park Foundation',
      shortcode: 'NPF',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_park_service_(nps)',
      label: 'National Park Service (NPS)',
      shortcode: 'NPS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_passport_information_center_(npic)',
      label: 'National Passport Information Center (NPIC)',
      shortcode: 'NPIC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_prevention_information_network',
      label: 'National Prevention Information Network',
      shortcode: 'NPIN',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_reconnaissance_office',
      label: 'National Reconnaissance Office',
      shortcode: 'NRO',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_science_foundation_(nsf)',
      label: 'National Science Foundation (NSF)',
      shortcode: 'NSF',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/NSF_logo.png/250px-NSF_logo.png',
    },
    {
      value: 'national_security_agency_(nsa)',
      label: 'National Security Agency (NSA)',
      shortcode: 'NSA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_security_council_(nsc)',
      label: 'National Security Council (NSC)',
      shortcode: 'NSC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_technical_information_service',
      label: 'National Technical Information Service',
      shortcode: 'NTIS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_telecommunications_and_information_administration',
      label: 'National Telecommunications and Information Administration',
      shortcode: 'NTIA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_transportation_safety_board_(ntsb)',
      label: 'National Transportation Safety Board (NTSB)',
      shortcode: 'NTSB',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/1/16/Seal_of_the_United_States_National_Transportation_Safety_Board.svg',
    },
    {
      value: 'national_war_college',
      label: 'National War College',
      shortcode: 'NWC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'national_weather_service',
      label: 'National Weather Service (NWS)',
      shortcode: 'NWS',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/ff/US-NationalWeatherService-Logo.svg',
    },
    {
      value: 'natural_resources_conservation_service',
      label: 'Natural Resources Conservation Service',
      shortcode: 'NRCS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'navy',
      label: 'Navy',
      shortcode: 'USN',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b1/Emblem_of_the_United_States_Navy.svg',
    },
    {
      value: 'noaa_fisheries',
      label: 'NOAA Fisheries',
      shortcode: 'NMFS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'northern_border_regional_commission',
      label: 'Northern Border Regional Commission',
      shortcode: 'NBRC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'northwest_power_and_conservation_council',
      label: 'Northwest Power and Conservation Council',
      shortcode: 'NPCC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'northwest_power_planning_council',
      label: 'Northwest Power Planning Council',
      shortcode: 'NPCC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'nuclear_regulatory_commission_(nrc)',
      label: 'Nuclear Regulatory Commission (NRC)',
      shortcode: 'NRC',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Seal_of_the_United_States_Nuclear_Regulatory_Commission.png/250px-Seal_of_the_United_States_Nuclear_Regulatory_Commission.png',
    },
    {
      value: 'nuclear_waste_technical_review_board',
      label: 'Nuclear Waste Technical Review Board',
      shortcode: 'NWTRB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'oak_ridge_national_laboratory',
      label: 'Oak Ridge National Laboratory',
      shortcode: 'ORNL',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'occupational_safety_and_health_administration_(osha)',
      label: 'Occupational Safety and Health Administration (OSHA)',
      shortcode: 'OSHA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'occupational_safety_and_health_review_commission',
      label: 'Occupational Safety and Health Review Commission',
      shortcode: 'OSHRC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_career_technical_and_adult_education',
      label: 'Office of Career Technical and Adult Education',
      shortcode: 'OCTAE',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_child_support_enforcement_(ocse)',
      label: 'Office of Child Support Enforcement (OCSE)',
      shortcode: 'OCSE',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_community_planning_and_development',
      label: 'Office of Community Planning and Development',
      shortcode: 'CPD',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_compliance',
      label: 'Office of Compliance',
      shortcode: 'Office of Compliance',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_cuba_broadcasting',
      label: 'Office of Cuba Broadcasting',
      shortcode: 'OCB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_disability_employment_policy_(odep)',
      label: 'Office of Disability Employment Policy (ODEP)',
      shortcode: 'ODEP',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_economic_adjustment',
      label: 'Office of Economic Adjustment',
      shortcode: 'OEA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_elementary_and_secondary_education',
      label: 'Office of Elementary and Secondary Education',
      shortcode: 'OESE',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_environmental_management',
      label: 'Office of Environmental Management',
      shortcode: 'EM',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_fair_housing_and_equal_opportunity_(fheo)',
      label: 'Office of Fair Housing and Equal Opportunity (FHEO)',
      shortcode: 'FHEO',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_fossil_energy',
      label: 'Office of Fossil Energy',
      shortcode: 'FE',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_government_ethics_(oge)',
      label: 'Office of Government Ethics (OGE)',
      shortcode: 'OGE',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_housing',
      label: 'Office of Housing',
      shortcode: 'N/A',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_immigrant_and_employee_rights_(ier)',
      label: 'Office of Immigrant and Employee Rights (IER)',
      shortcode: 'IER',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_investor_education_and_advocacy',
      label: 'Office of Investor Education and Advocacy',
      shortcode: 'N/A',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_justice_programs',
      label: 'Office of Justice Programs',
      shortcode: 'OJP',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_juvenile_justice_and_delinquency_prevention',
      label: 'Office of Juvenile Justice and Delinquency Prevention',
      shortcode: 'OJJDP',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_lead_hazard_control_and_healthy_homes',
      label: 'Office of Lead Hazard Control and Healthy Homes',
      shortcode: 'OLHCHH',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_management_and_budget_(omb)',
      label: 'Office of Management and Budget (OMB)',
      shortcode: 'OMB',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/7/73/US-OfficeOfManagementAndBudget-Seal.svg',
    },
    {
      value: 'office_of_manufactured_housing_programs',
      label: 'Office of Manufactured Housing Programs',
      shortcode: 'Office of Manufactured Housing Programs',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_minority_health',
      label: 'Office of Minority Health',
      shortcode: 'OMH',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_national_drug_control_policy_(ondcp)',
      label: 'Office of National Drug Control Policy (ONDCP)',
      shortcode: 'ONDCP',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_natural_resources_revenue',
      label: 'Office of Natural Resources Revenue',
      shortcode: 'ONRR',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_nuclear_energy',
      label: 'Office of Nuclear Energy',
      shortcode: 'NE',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0b/Seal_of_the_Department_of_Energy.svg',
    },
    {
      value: 'office_of_personnel_management_(opm)',
      label: 'Office of Personnel Management (OPM)',
      shortcode: 'OPM',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0a/Seal_of_the_United_States_Office_of_Personnel_Management.svg',
    },
    {
      value: 'office_of_policy_development_and_research',
      label: 'Office of Policy Development and Research',
      shortcode: 'PD&R',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_postsecondary_education',
      label: 'Office of Postsecondary Education',
      shortcode: 'OPE',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_refugee_resettlement',
      label: 'Office of Refugee Resettlement',
      shortcode: 'ORR',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_science_and_technology_policy',
      label: 'Office of Science and Technology Policy',
      shortcode: 'OSTP',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_scientific_and_technical_information',
      label: 'Office of Scientific and Technical Information',
      shortcode: 'OSTI',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_servicemember_affairs',
      label: 'Office of Servicemember Affairs',
      shortcode: 'Office of Servicemember Affairs',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_special_counsel',
      label: 'Office of Special Counsel',
      shortcode: 'OSC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_special_education_and_rehabilitative_services_(osers)',
      label: 'Office of Special Education and Rehabilitative Services (OSERS)',
      shortcode: 'OSERS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_surface_mining_reclamation_and_enforcement_(osmre)',
      label: 'Office of Surface Mining Reclamation and Enforcement (OSMRE)',
      shortcode: 'OSMRE',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_the_comptroller_of_the_currency_(occ)',
      label: 'Office of the Comptroller of the Currency (OCC)',
      shortcode: 'OCC',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a0/Seal_of_the_Office_of_the_Comptroller_of_the_Currency.svg',
    },
    {
      value: 'office_of_the_director_of_national_intelligence_(odni)',
      label: 'Office of the Director of National Intelligence (ODNI)',
      shortcode: 'ODNI',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_the_federal_register',
      label: 'Office of the Federal Register',
      shortcode: 'OFR',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_of_the_pardon_attorney',
      label: 'Office of the Pardon Attorney',
      shortcode: 'OPA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'office_on_violence_against_women_(ovw)',
      label: 'Office on Violence Against Women (OVW)',
      shortcode: 'OVW',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'open_world_leadership_center',
      label: 'Open World Leadership Center',
      shortcode: 'OWLC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'other',
      label: 'Other',
      shortcode: 'Other',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'overseas_private_investment_corporation',
      label: 'Overseas Private Investment Corporation',
      shortcode: 'OPIC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value:
        'pacific_northwest_electric_power_and_conservation_planning_council',
      label:
        'Pacific Northwest Electric Power and Conservation Planning Council',
      shortcode: 'N/A',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'peace_corps',
      label: 'Peace Corps',
      shortcode: 'Peace Corps',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/b/ba/Peace_corps_logo16.svg',
    },
    {
      value: 'pension_benefit_guaranty_corporation_(pbgc)',
      label: 'Pension Benefit Guaranty Corporation (PBGC)',
      shortcode: 'PBGC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'pentagon_force_protection_agency',
      label: 'Pentagon Force Protection Agency',
      shortcode: 'PFPA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/9/93/Seal_of_the_Pentagon_Force_Protection_Agency.png',
    },
    {
      value: 'pipeline_and_hazardous_materials_safety_administration',
      label: 'Pipeline and Hazardous Materials Safety Administration',
      shortcode: 'PHMSA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'political_affairs',
      label: 'Political Affairs',
      shortcode: 'N/A',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'postal_regulatory_commission',
      label: 'Postal Regulatory Commission',
      shortcode: 'PRC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'power_administrations',
      label: 'Power Administrations',
      shortcode: 'Power Administrations',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'presidential_scholars_commission',
      label: 'Presidential Scholars Commission',
      shortcode: 'Presidential Scholars Commission',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'presidents_council_on_fitness_sports_and_nutrition',
      label: 'Presidents Council on Fitness Sports and Nutrition',
      shortcode: 'PCFSN',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'presidio_trust',
      label: 'Presidio Trust',
      shortcode: 'Presidio Trust',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'pretrial_services_agency_for_the_district_of_columbia',
      label: 'Pretrial Services Agency for the District of Columbia',
      shortcode: 'PSA-DC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'prisoner_of_war_and_missing_in_action_accounting_agency',
      label: 'Prisoner of War and Missing in Action Accounting Agency',
      shortcode: 'DPAA (formerly JPAC)',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'privacy_and_civil_liberties_oversight_board_(pclob)',
      label: 'Privacy and Civil Liberties Oversight Board (PCLOB)',
      shortcode: 'PCLOB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'private_sector_-_non_federal',
      label: 'Private Sector - Non Federal',
      shortcode: 'Private Sector',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'public_and_indian_housing',
      label: 'Public and Indian Housing',
      shortcode: 'PIH',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'public_diplomacy_and_public_affairs',
      label: 'Public Diplomacy and Public Affairs',
      shortcode: 'Public Diplomacy and Public Affairs',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'radio_and_tv_martí',
      label: 'Radio and TV Martí',
      shortcode: 'Radio and TV Martí',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'radio_free_asia_(rfa)',
      label: 'Radio Free Asia (RFA)',
      shortcode: 'RFA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'radio_free_europe_and_radio_liberty_(rfe/rl)',
      label: 'Radio Free Europe and Radio Liberty (RFE/RL)',
      shortcode: 'RFE/RL',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'radio_sawa',
      label: 'Radio Sawa',
      shortcode: 'Radio Sawa',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'railroad_retirement_board_(rrb)',
      label: 'Railroad Retirement Board (RRB)',
      shortcode: 'RRB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'rehabilitation_services_administration',
      label: 'Rehabilitation Services Administration',
      shortcode: 'RSA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'research_and_innovative_technology_administration',
      label: 'Research and Innovative Technology Administration',
      shortcode: 'RITA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'risk_management_agency',
      label: 'Risk Management Agency',
      shortcode: 'RMA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'rural_business_and_cooperative_programs',
      label: 'Rural Business and Cooperative Programs',
      shortcode: 'Rural Business and Cooperative Programs',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'rural_development',
      label: 'Rural Development',
      shortcode: 'RD',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/c/ca/USDA-RuralDevelopment-Logo.svg',
    },
    {
      value: 'rural_housing_service',
      label: 'Rural Housing Service',
      shortcode: 'RHS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'rural_utilities_service',
      label: 'Rural Utilities Service',
      shortcode: 'RUS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'saint_lawrence_seaway_development_corporation',
      label: 'Saint Lawrence Seaway Development Corporation',
      shortcode: 'SLSDC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'science_office',
      label: 'Science Office',
      shortcode: 'Science Office',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'seafood_inspection_program',
      label: 'Seafood Inspection Program',
      shortcode: 'Seafood Inspection Program',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'secret_service_(uss)',
      label: 'Secret Service (USS)',
      shortcode: 'USS',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b5/Logo_of_the_United_States_Secret_Service.svg',
    },
    {
      value: 'securities_and_exchange_commission_(sec)',
      label: 'Securities and Exchange Commission (SEC)',
      shortcode: 'SEC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'selective_service_system_(sss)',
      label: 'Selective Service System (SSS)',
      shortcode: 'SSS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'senior_corps',
      label: 'Senior Corps',
      shortcode: 'Senior Corps',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'small_business_administration_(sba)',
      label: 'Small Business Administration (SBA)',
      shortcode: 'SBA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/7/7f/Seal_of_the_United_States_Small_Business_Administration.svg',
    },
    {
      value: 'smithsonian_institution',
      label: 'Smithsonian Institution',
      shortcode: 'SI',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/7/7e/Smithsonian_logo_color.svg',
    },
    {
      value: 'social_security_administration_(ssa)',
      label: 'Social Security Administration (SSA)',
      shortcode: 'SSA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/26/US-SocialSecurityAdmin-Seal.svg',
    },
    {
      value: 'social_security_advisory_board',
      label: 'Social Security Advisory Board',
      shortcode: 'SSAB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'southeastern_power_administration',
      label: 'Southeastern Power Administration',
      shortcode: 'SEPA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'southwestern_power_administration',
      label: 'Southwestern Power Administration',
      shortcode: 'SWPA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'special_forces_operations_command',
      label: 'Special Forces Operations Command',
      shortcode: 'Special Forces Operations Command',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'state_justice_institute',
      label: 'State Justice Institute',
      shortcode: 'SJI',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'stennis_center_for_public_service',
      label: 'Stennis Center for Public Service',
      shortcode: 'Stennis Center for Public Service',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value:
        'substance_abuse_and_mental_health_services_administration_(samhsa)',
      label:
        'Substance Abuse and Mental Health Services Administration (SAMHSA)',
      shortcode: 'SAMHSA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'supreme_court_of_the_united_states',
      label: 'Supreme Court of the United States',
      shortcode: 'SCOTUS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'surface_transportation_board',
      label: 'Surface Transportation Board',
      shortcode: 'STB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'susquehanna_river_basin_commission',
      label: 'Susquehanna River Basin Commission',
      shortcode: 'SRBC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'tax_court',
      label: 'Tax Court',
      shortcode: 'Tax Court',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'taxpayer_advocacy_panel',
      label: 'Taxpayer Advocacy Panel',
      shortcode: 'TAP',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'tennessee_valley_authority_(tva)',
      label: 'Tennessee Valley Authority (TVA)',
      shortcode: 'TVA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'transportation_security_administration_(tsa)',
      label: 'Transportation Security Administration (TSA)',
      shortcode: 'TSA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/e/e4/Transportation_Security_Administration_seal.svg',
    },
    {
      value: 'u.s._access_board',
      label: 'U.S. Access Board',
      shortcode: 'U.S. Access Board',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._agency_for_global_media',
      label: 'U.S. Agency for Global Media',
      shortcode: 'USAGM',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._agency_for_international_development_(usaid)',
      label: 'U.S. Agency for International Development (USAID)',
      shortcode: 'USAID',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/4/43/USAID-Seal.svg',
    },
    {
      value: 'u.s._air_force',
      label: 'U.S. Air Force',
      shortcode: 'USAF',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/9/98/US_Air_Force_Logo_-_Black_and_White_Version.svg',
    },
    {
      value: 'u.s._air_force_reserve_command',
      label: 'U.S. Air Force Reserve Command',
      shortcode: 'AFRC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._arctic_research_commission',
      label: 'U.S. Arctic Research Commission',
      shortcode: 'USARC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._army',
      label: 'U.S. Army',
      shortcode: 'Army',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/24/Mark_of_the_United_States_Army.svg',
    },
    {
      value: 'u.s._botanic_garden',
      label: 'U.S. Botanic Garden',
      shortcode: 'USBG',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._capitol_visitor_center',
      label: 'U.S. Capitol Visitor Center',
      shortcode: 'U.S. Capitol Visitor Center',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._census_bureau',
      label: 'U.S. Census Bureau',
      shortcode: 'USCB',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/8/85/Seal_of_the_United_States_Census_Bureau.svg',
    },
    {
      value: 'u.s._central_command_(centcom)',
      label: 'U.S. Central Command (CENTCOM)',
      shortcode: 'CENTCOM',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._chemical_safety_board',
      label: 'U.S. Chemical Safety Board',
      shortcode: 'CSB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._coast_guard',
      label: 'U.S. Coast Guard',
      shortcode: 'USCG',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/e/e5/Mark_of_the_U.S._Coast_Guard.svg',
    },
    {
      value: 'u.s._commission_of_fine_arts',
      label: 'U.S. Commission of Fine Arts',
      shortcode: 'CFA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._commission_on_international_religious_freedom',
      label: 'U.S. Commission on International Religious Freedom',
      shortcode: 'USCIRF',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._court_of_appeals_for_veterans_claims',
      label: 'U.S. Court of Appeals for Veterans Claims',
      shortcode: 'U.S. Court of Appeals for Veterans Claims',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._courts_of_appeal',
      label: 'U.S. Courts of Appeal',
      shortcode: 'U.S. Courts of Appeal',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._european_command',
      label: 'U.S. European Command',
      shortcode: 'EUCOM',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._fire_administration_(usfa)',
      label: 'U.S. Fire Administration (USFA)',
      shortcode: 'USFA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._fleet_forces_command',
      label: 'U.S. Fleet Forces Command',
      shortcode: 'USFF',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._geological_survey_(usgs)',
      label: 'U.S. Geological Survey (USGS)',
      shortcode: 'USGS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._house_of_representatives',
      label: 'U.S. House of Representatives',
      shortcode: 'U.S. House of Representatives',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._international_trade_commission',
      label: 'U.S. International Trade Commission',
      shortcode: 'USITC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._military_academy_-_west_point',
      label: 'U.S. Military Academy - West Point',
      shortcode: 'USMA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._mission_to_the_united_nations',
      label: 'U.S. Mission to the United Nations',
      shortcode: 'USUN',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._national_central_bureau_-_interpol',
      label: 'U.S. National Central Bureau - Interpol',
      shortcode: 'USNCB',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._northern_command',
      label: 'U.S. Northern Command',
      shortcode: 'NORTHCOM',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._pacific_command',
      label: 'U.S. Pacific Command',
      shortcode: 'PACOM',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._parole_commission',
      label: 'U.S. Parole Commission',
      shortcode: 'USPC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._patent_and_trademark_office',
      label: 'U.S. Patent and Trademark Office',
      shortcode: 'USPTO',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/7/75/Seal_of_the_United_States_Patent_and_Trademark_Office.svg',
    },
    {
      value: 'u.s._postal_inspection_service',
      label: 'U.S. Postal Inspection Service',
      shortcode: 'USPIS',
      jobRetention: 0.99,
      logo: 'https://www.uspis.gov/wp-content/themes/uspis/images/logo.svg',
    },
    {
      value: 'u.s._postal_service_(usps)',
      label: 'U.S. Postal Service (USPS)',
      shortcode: 'USPS',
      jobRetention: 0.99,
      logo: 'https://www.usps.com/assets/images/home/favicon.ico',
    },
    {
      value: 'u.s._senate',
      label: 'U.S. Senate',
      shortcode: 'Senate',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f0/Seal_of_the_United_States_Senate.svg',
    },
    {
      value: 'u.s._sentencing_commission',
      label: 'U.S. Sentencing Commission',
      shortcode: 'USSC',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._southern_command',
      label: 'U.S. Southern Command',
      shortcode: 'SOUTHCOM',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._special_operations_command',
      label: 'U.S. Special Operations Command',
      shortcode: 'USSOCOM',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._strategic_command',
      label: 'U.S. Strategic Command',
      shortcode: 'STRATCOM',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._trade_and_development_agency',
      label: 'U.S. Trade and Development Agency',
      shortcode: 'TDA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._trade_representative',
      label: 'U.S. Trade Representative',
      shortcode: 'USTR',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._transportation_command',
      label: 'U.S. Transportation Command',
      shortcode: 'USTRANSCOM',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'u.s._trustee_program',
      label: 'U.S. Trustee Program',
      shortcode: 'USTP',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'unified_combatant_commands',
      label: 'Unified Combatant Commands',
      shortcode: 'Unified Combatant Commands',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'uniformed_services_university_of_the_health_sciences',
      label: 'Uniformed Services University of the Health Sciences',
      shortcode: 'USUHS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'united_states_capitol_police_(uscp)',
      label: 'United States Capitol Police (USCP)',
      shortcode: 'USCP',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'usagov',
      label: 'USAGov',
      shortcode: 'USAGov',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2a/USA.gov_logo_as_of_2017.png',
    },
    {
      value: 'veterans_benefits_administration_(vba)',
      label: 'Veterans Benefits Administration (VBA)',
      shortcode: 'VBA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/8/80/US_Veterans_Benefits_Administration_logo_stacked.png',
    },
    {
      value: 'veterans_day_national_committee',
      label: 'Veterans Day National Committee',
      shortcode: 'Veterans Day National Committee',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'veterans_employment_and_training_service_(vets)',
      label: 'Veterans Employment and Training Service (VETS)',
      shortcode: 'VETS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'veterans_health_administration_(vha)',
      label: 'Veterans Health Administration (VHA)',
      shortcode: 'VHA',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/0/05/Seal_of_the_U.S._Department_of_Veterans_Affairs.svg',
    },
    {
      value: 'voice_of_america_(voa)',
      label: 'Voice of America (VOA)',
      shortcode: 'VOA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'washington_headquarters_services',
      label: 'Washington Headquarters Services',
      shortcode: 'WHS',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'weights_and_measures_division',
      label: 'Weights and Measures Division',
      shortcode: 'Weights and Measures Division',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'western_area_power_administration',
      label: 'Western Area Power Administration',
      shortcode: 'WAPA',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'white_house',
      label: 'White House',
      shortcode: 'White House',
      jobRetention: 0.99,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/5/5e/US-WhiteHouse-Logo.svg',
    },
    {
      value: 'wireless_telecommunications_bureau',
      label: 'Wireless Telecommunications Bureau',
      shortcode: 'Wireless Telecommunications Bureau',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'womens_bureau',
      label: 'Womens Bureau',
      shortcode: 'Womens Bureau',
      jobRetention: 0.99,
      logo: '',
    },
    {
      value: 'woodrow_wilson_international_center_for_scholars',
      label: 'Woodrow Wilson International Center for Scholars',
      shortcode: 'Wilson Center',
      jobRetention: 0.99,
      logo: '',
    },
  ],
  fehbCode: [
    { value: 'Z24', label: 'Z24 - Aetna Advantage' },
    { value: 'Z25', label: 'Z25 - Aetna Advantage' },
    { value: 'Z26', label: 'Z26 - Aetna Advantage' },
    { value: 'N61', label: 'N61 - Aetna Direct ' },
    { value: 'N62', label: 'N62 - Aetna Direct ' },
    { value: 'N63', label: 'N63 - Aetna Direct ' },
    { value: 'F51', label: 'F51 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'F52', label: 'F52 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'F53', label: 'F53 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'F54', label: 'F54 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'F55', label: 'F55 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'F56', label: 'F56 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: '224', label: '224 - Aetna HealthFund HDHP' },
    { value: '225', label: '225 - Aetna HealthFund HDHP' },
    { value: '226', label: '226 - Aetna HealthFund HDHP' },
    {
      value: 'AS1',
      label:
        'AS1 - UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary',
    },
    {
      value: 'AS2',
      label:
        'AS2 - UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary',
    },
    {
      value: 'AS3',
      label:
        'AS3 - UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary',
    },
    {
      value: 'LS1',
      label: 'LS1 - UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    },
    {
      value: 'LS2',
      label: 'LS2 - UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    },
    {
      value: 'LS3',
      label: 'LS3 - UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    },
    {
      value: 'Y81',
      label: 'Y81 - UnitedHealthcare Insurance Company, Inc. Choice Primary ',
    },
    {
      value: 'Y82',
      label: 'Y82 - UnitedHealthcare Insurance Company, Inc. Choice Primary ',
    },
    {
      value: 'Y83',
      label: 'Y83 - UnitedHealthcare Insurance Company, Inc. Choice Primary ',
    },
    { value: 'JS4', label: 'JS4 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'JS5', label: 'JS5 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'JS6', label: 'JS6 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'JS1', label: 'JS1 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'JS2', label: 'JS2 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'JS3', label: 'JS3 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'G54', label: 'G54 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'G55', label: 'G55 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'G56', label: 'G56 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'G51', label: 'G51 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'G52', label: 'G52 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'G53', label: 'G53 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'WQ1', label: 'WQ1 - Aetna Open Access' },
    { value: 'WQ2', label: 'WQ2 - Aetna Open Access' },
    { value: 'WQ3', label: 'WQ3 - Aetna Open Access' },
    {
      value: 'WF1',
      label:
        'WF1 - UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary',
    },
    {
      value: 'WF2',
      label:
        'WF2 - UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary',
    },
    {
      value: 'WF3',
      label:
        'WF3 - UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary',
    },
    {
      value: 'LU1',
      label: 'LU1 - UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    },
    {
      value: 'LU2',
      label: 'LU2 - UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    },
    {
      value: 'LU3',
      label: 'LU3 - UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    },
    {
      value: 'VD1',
      label: 'VD1 - UnitedHealthcare Insurance Company, Inc. Choice Primary ',
    },
    {
      value: 'VD2',
      label: 'VD2 - UnitedHealthcare Insurance Company, Inc. Choice Primary ',
    },
    {
      value: 'VD3',
      label: 'VD3 - UnitedHealthcare Insurance Company, Inc. Choice Primary ',
    },
    { value: 'DH1', label: 'DH1 - QualChoice' },
    { value: 'DH2', label: 'DH2 - QualChoice' },
    { value: 'DH3', label: 'DH3 - QualChoice' },
    { value: 'DH4', label: 'DH4 - QualChoice' },
    { value: 'DH5', label: 'DH5 - QualChoice' },
    { value: 'DH6', label: 'DH6 - QualChoice' },
    { value: '2X1', label: '2X1 - Aetna Open Access' },
    { value: '2X2', label: '2X2 - Aetna Open Access' },
    { value: '2X3', label: '2X3 - Aetna Open Access' },
    { value: 'B31', label: 'B31 - Anthem Blue Cross Select HMO' },
    { value: 'B32', label: 'B32 - Anthem Blue Cross Select HMO' },
    { value: 'B33', label: 'B33 - Anthem Blue Cross Select HMO' },
    { value: 'LB1', label: 'LB1 - Health Net of California ' },
    { value: 'LB2', label: 'LB2 - Health Net of California ' },
    { value: 'LB3', label: 'LB3 - Health Net of California ' },
    { value: 'P61', label: 'P61 - Health Net of California ' },
    { value: 'P62', label: 'P62 - Health Net of California ' },
    { value: 'P63', label: 'P63 - Health Net of California ' },
    { value: 'P64', label: 'P64 - Health Net of California ' },
    { value: 'P65', label: 'P65 - Health Net of California ' },
    { value: 'P66', label: 'P66 - Health Net of California ' },
    { value: 'LP1', label: 'LP1 - Health Net of California ' },
    { value: 'LP2', label: 'LP2 - Health Net of California ' },
    { value: 'LP3', label: 'LP3 - Health Net of California ' },
    { value: 'NZ4', label: 'NZ4 - Kaiser Permanente - Fresno California' },
    { value: 'NZ5', label: 'NZ5 - Kaiser Permanente - Fresno California' },
    { value: 'NZ6', label: 'NZ6 - Kaiser Permanente - Fresno California' },
    { value: 'NZ1', label: 'NZ1 - Kaiser Permanente - Fresno California' },
    { value: 'NZ2', label: 'NZ2 - Kaiser Permanente - Fresno California' },
    { value: 'NZ3', label: 'NZ3 - Kaiser Permanente - Fresno California' },
    { value: 'KC1', label: 'KC1 - Kaiser Permanente - Northern California' },
    { value: 'KC2', label: 'KC2 - Kaiser Permanente - Northern California' },
    { value: 'KC3', label: 'KC3 - Kaiser Permanente - Northern California' },
    { value: '591', label: '591 - Kaiser Permanente - Northern California' },
    { value: '592', label: '592 - Kaiser Permanente - Northern California' },
    { value: '593', label: '593 - Kaiser Permanente - Northern California' },
    { value: '594', label: '594 - Kaiser Permanente - Northern California' },
    { value: '595', label: '595 - Kaiser Permanente - Northern California' },
    { value: '596', label: '596 - Kaiser Permanente - Northern California' },
    { value: 'FL1', label: 'FL1 - Kaiser Permanente - Southern California' },
    { value: 'FL2', label: 'FL2 - Kaiser Permanente - Southern California' },
    { value: 'FL3', label: 'FL3 - Kaiser Permanente - Southern California' },
    { value: '624', label: '624 - Kaiser Permanente - Southern California' },
    { value: '625', label: '625 - Kaiser Permanente - Southern California' },
    { value: '626', label: '626 - Kaiser Permanente - Southern California' },
    { value: '621', label: '621 - Kaiser Permanente - Southern California' },
    { value: '622', label: '622 - Kaiser Permanente - Southern California' },
    { value: '623', label: '623 - Kaiser Permanente - Southern California' },
    { value: 'YJ4', label: 'YJ4 - Sharp Health Plan' },
    { value: 'YJ5', label: 'YJ5 - Sharp Health Plan' },
    { value: 'YJ6', label: 'YJ6 - Sharp Health Plan' },
    { value: 'W51', label: 'W51 - Western Health Advantage' },
    { value: 'W52', label: 'W52 - Western Health Advantage' },
    { value: 'W53', label: 'W53 - Western Health Advantage' },
    { value: '654', label: '654 - Kaiser Permanente - Colorado' },
    { value: '655', label: '655 - Kaiser Permanente - Colorado' },
    { value: '656', label: '656 - Kaiser Permanente - Colorado' },
    { value: '651', label: '651 - Kaiser Permanente - Colorado' },
    { value: '652', label: '652 - Kaiser Permanente - Colorado' },
    { value: '653', label: '653 - Kaiser Permanente - Colorado' },
    { value: 'N41', label: 'N41 - Kaiser Permanente - Colorado' },
    { value: 'N42', label: 'N42 - Kaiser Permanente - Colorado' },
    { value: 'N43', label: 'N43 - Kaiser Permanente - Colorado' },
    { value: 'EP4', label: 'EP4 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'EP5', label: 'EP5 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'EP6', label: 'EP6 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'EP1', label: 'EP1 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'EP2', label: 'EP2 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'EP3', label: 'EP3 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'P34', label: 'P34 - Aetna Open Access' },
    { value: 'P35', label: 'P35 - Aetna Open Access' },
    { value: 'P36', label: 'P36 - Aetna Open Access' },
    { value: 'P31', label: 'P31 - Aetna Open Access' },
    { value: 'P32', label: 'P32 - Aetna Open Access' },
    { value: 'P33', label: 'P33 - Aetna Open Access' },
    { value: 'JN1', label: 'JN1 - Aetna Open Access' },
    { value: 'JN2', label: 'JN2 - Aetna Open Access' },
    { value: 'JN3', label: 'JN3 - Aetna Open Access' },
    { value: 'JN4', label: 'JN4 - Aetna Open Access' },
    { value: 'JN5', label: 'JN5 - Aetna Open Access' },
    { value: 'JN6', label: 'JN6 - Aetna Open Access' },
    { value: 'QQ4', label: 'QQ4 - Aetna Saver (Open Access) ' },
    { value: 'QQ5', label: 'QQ5 - Aetna Saver (Open Access) ' },
    { value: 'QQ6', label: 'QQ6 - Aetna Saver (Open Access) ' },
    { value: '2G4', label: '2G4 - CareFirst BlueChoice' },
    { value: '2G5', label: '2G5 - CareFirst BlueChoice' },
    { value: '2G6', label: '2G6 - CareFirst BlueChoice' },
    { value: 'B61', label: 'B61 - CareFirst BlueChoice' },
    { value: 'B62', label: 'B62 - CareFirst BlueChoice' },
    { value: 'B63', label: 'B63 - CareFirst BlueChoice' },
    { value: 'B64', label: 'B64 - CareFirst BlueChoice' },
    { value: 'B65', label: 'B65 - CareFirst BlueChoice' },
    { value: 'B66', label: 'B66 - CareFirst BlueChoice' },
    { value: 'T71', label: 'T71 - Kaiser Permanente - Mid-Atlantic States' },
    { value: 'T72', label: 'T72 - Kaiser Permanente - Mid-Atlantic States' },
    { value: 'T73', label: 'T73 - Kaiser Permanente - Mid-Atlantic States' },
    { value: 'E34', label: 'E34 - Kaiser Permanente - Mid-Atlantic States' },
    { value: 'E35', label: 'E35 - Kaiser Permanente - Mid-Atlantic States' },
    { value: 'E36', label: 'E36 - Kaiser Permanente - Mid-Atlantic States' },
    { value: 'E31', label: 'E31 - Kaiser Permanente - Mid-Atlantic States' },
    { value: 'E32', label: 'E32 - Kaiser Permanente - Mid-Atlantic States' },
    { value: 'E33', label: 'E33 - Kaiser Permanente - Mid-Atlantic States' },
    { value: 'JP1', label: 'JP1 - M.D. IPA ' },
    { value: 'JP2', label: 'JP2 - M.D. IPA ' },
    { value: 'JP3', label: 'JP3 - M.D. IPA ' },
    {
      value: 'V41',
      label: 'V41 - UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    },
    {
      value: 'V42',
      label: 'V42 - UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    },
    {
      value: 'V43',
      label: 'V43 - UnitedHealthcare Insurance Company, Inc. Choice HDHP',
    },
    {
      value: 'LR1',
      label:
        'LR1 - UnitedHealthcare Insurance Company, Inc. Choice Open Access HMO',
    },
    {
      value: 'LR2',
      label:
        'LR2 - UnitedHealthcare Insurance Company, Inc. Choice Open Access HMO',
    },
    {
      value: 'LR3',
      label:
        'LR3 - UnitedHealthcare Insurance Company, Inc. Choice Open Access HMO',
    },
    {
      value: 'L91',
      label:
        'L91 - UnitedHealthcare Insurance Company, Inc. Choice Plus Advanced',
    },
    {
      value: 'L92',
      label:
        'L92 - UnitedHealthcare Insurance Company, Inc. Choice Plus Advanced',
    },
    {
      value: 'L93',
      label:
        'L93 - UnitedHealthcare Insurance Company, Inc. Choice Plus Advanced',
    },
    { value: 'WZ1', label: 'WZ1 - AvMed' },
    { value: 'WZ2', label: 'WZ2 - AvMed' },
    { value: 'WZ3', label: 'WZ3 - AvMed' },
    { value: 'ML4', label: 'ML4 - AvMed' },
    { value: 'ML5', label: 'ML5 - AvMed' },
    { value: 'ML6', label: 'ML6 - AvMed' },
    { value: 'EA1', label: 'EA1 - Capital Health Plan' },
    { value: 'EA2', label: 'EA2 - Capital Health Plan' },
    { value: 'EA3', label: 'EA3 - Capital Health Plan' },
    { value: '2U1', label: '2U1 - Aetna Open Access' },
    { value: '2U2', label: '2U2 - Aetna Open Access' },
    { value: '2U3', label: '2U3 - Aetna Open Access' },
    { value: 'F81', label: 'F81 - Kaiser Permanente - Georgia' },
    { value: 'F82', label: 'F82 - Kaiser Permanente - Georgia' },
    { value: 'F83', label: 'F83 - Kaiser Permanente - Georgia' },
    { value: 'F84', label: 'F84 - Kaiser Permanente - Georgia' },
    { value: 'F85', label: 'F85 - Kaiser Permanente - Georgia' },
    { value: 'F86', label: 'F86 - Kaiser Permanente - Georgia' },
    { value: 'LA1', label: 'LA1 - Kaiser Permanente - Georgia' },
    { value: 'LA2', label: 'LA2 - Kaiser Permanente - Georgia' },
    { value: 'LA3', label: 'LA3 - Kaiser Permanente - Georgia' },
    { value: 'B44', label: "B44 - Calvo's SelectCare" },
    { value: 'B45', label: "B45 - Calvo's SelectCare" },
    { value: 'B46', label: "B46 - Calvo's SelectCare" },
    { value: 'B41', label: "B41 - Calvo's SelectCare" },
    { value: 'B42', label: "B42 - Calvo's SelectCare" },
    { value: 'B43', label: "B43 - Calvo's SelectCare" },
    { value: 'KX1', label: 'KX1 - TakeCare' },
    { value: 'KX2', label: 'KX2 - TakeCare' },
    { value: 'KX3', label: 'KX3 - TakeCare' },
    { value: 'JK4', label: 'JK4 - TakeCare' },
    { value: 'JK5', label: 'JK5 - TakeCare' },
    { value: 'JK6', label: 'JK6 - TakeCare' },
    { value: 'JK1', label: 'JK1 - TakeCare' },
    { value: 'JK2', label: 'JK2 - TakeCare' },
    { value: 'JK3', label: 'JK3 - TakeCare' },
    { value: '871', label: '871 - HMSA Plan' },
    { value: '872', label: '872 - HMSA Plan' },
    { value: '873', label: '873 - HMSA Plan' },
    { value: '874', label: '874 - HMSA Plan' },
    { value: '875', label: '875 - HMSA Plan' },
    { value: '876', label: '876 - HMSA Plan' },
    { value: '631', label: '631 - Kaiser Permanente - Hawaii' },
    { value: '632', label: '632 - Kaiser Permanente - Hawaii' },
    { value: '633', label: '633 - Kaiser Permanente - Hawaii' },
    { value: '634', label: '634 - Kaiser Permanente - Hawaii' },
    { value: '635', label: '635 - Kaiser Permanente - Hawaii' },
    { value: '636', label: '636 - Kaiser Permanente - Hawaii' },
    { value: 'H41', label: 'H41 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'H42', label: 'H42 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'H43', label: 'H43 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'H44', label: 'H44 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'H45', label: 'H45 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: 'H46', label: 'H46 - Aetna HealthFund CDHP and Aetna Value Plan' },
    { value: '9K1', label: '9K1 - Altius Health Plan' },
    { value: '9K2', label: '9K2 - Altius Health Plan' },
    { value: '9K3', label: '9K3 - Altius Health Plan' },
    { value: '9K4', label: '9K4 - Altius Health Plan' },
    { value: '9K5', label: '9K5 - Altius Health Plan' },
    { value: '9K6', label: '9K6 - Altius Health Plan' },
    { value: 'DK4', label: 'DK4 - Altius Health Plan ' },
    { value: 'DK5', label: 'DK5 - Altius Health Plan ' },
    { value: 'DK6', label: 'DK6 - Altius Health Plan ' },
    { value: '544', label: '544 - Kaiser Permanente - Washington Core' },
    { value: '545', label: '545 - Kaiser Permanente - Washington Core' },
    { value: '546', label: '546 - Kaiser Permanente - Washington Core' },
    { value: '541', label: '541 - Kaiser Permanente - Washington Core' },
    { value: '542', label: '542 - Kaiser Permanente - Washington Core' },
    { value: '543', label: '543 - Kaiser Permanente - Washington Core' },
    { value: 'PT4', label: 'PT4 - Kaiser Permanente - Washington Core' },
    { value: 'PT5', label: 'PT5 - Kaiser Permanente - Washington Core' },
    { value: 'PT6', label: 'PT6 - Kaiser Permanente - Washington Core' },
    { value: 'K84', label: 'K84 - Health Alliance HMO' },
    { value: 'K85', label: 'K85 - Health Alliance HMO' },
    { value: 'K86', label: 'K86 - Health Alliance HMO' },
    { value: 'V34', label: 'V34 - HealthPartners' },
    { value: 'V35', label: 'V35 - HealthPartners' },
    { value: 'V36', label: 'V36 - HealthPartners' },
    { value: 'V31', label: 'V31 - HealthPartners' },
    { value: 'V32', label: 'V32 - HealthPartners' },
    { value: 'V33', label: 'V33 - HealthPartners' },
    { value: 'LX1', label: 'LX1 - Blue Care Network of Michigan' },
    { value: 'LX2', label: 'LX2 - Blue Care Network of Michigan' },
    { value: 'LX3', label: 'LX3 - Blue Care Network of Michigan' },
    { value: 'K51', label: 'K51 - Blue Care Network of Michigan' },
    { value: 'K52', label: 'K52 - Blue Care Network of Michigan' },
    { value: 'K53', label: 'K53 - Blue Care Network of Michigan' },
    { value: '521', label: '521 - Health Alliance Plan' },
    { value: '522', label: '522 - Health Alliance Plan' },
    { value: '523', label: '523 - Health Alliance Plan' },
    { value: 'GY4', label: 'GY4 - Health Alliance Plan' },
    { value: 'GY5', label: 'GY5 - Health Alliance Plan' },
    { value: 'GY6', label: 'GY6 - Health Alliance Plan' },
    { value: 'LE1', label: 'LE1 - Priority Health' },
    { value: 'LE2', label: 'LE2 - Priority Health' },
    { value: 'LE3', label: 'LE3 - Priority Health' },
    { value: 'LE4', label: 'LE4 - Priority Health' },
    { value: 'LE5', label: 'LE5 - Priority Health' },
    { value: 'LE6', label: 'LE6 - Priority Health' },
    { value: 'Y41', label: 'Y41 - Priority Health' },
    { value: 'Y42', label: 'Y42 - Priority Health' },
    { value: 'Y43', label: 'Y43 - Priority Health' },
    { value: 'NM1', label: 'NM1 - Health Plan of Nevada, Inc.' },
    { value: 'NM2', label: 'NM2 - Health Plan of Nevada, Inc.' },
    { value: 'NM3', label: 'NM3 - Health Plan of Nevada, Inc.' },
    { value: 'JR1', label: 'JR1 - Aetna Open Access' },
    { value: 'JR2', label: 'JR2 - Aetna Open Access' },
    { value: 'JR3', label: 'JR3 - Aetna Open Access' },
    { value: 'JR4', label: 'JR4 - Aetna Open Access' },
    { value: 'JR5', label: 'JR5 - Aetna Open Access' },
    { value: 'JR6', label: 'JR6 - Aetna Open Access' },
    { value: 'P21', label: 'P21 - Presbyterian Health Plan' },
    { value: 'P22', label: 'P22 - Presbyterian Health Plan' },
    { value: 'P23', label: 'P23 - Presbyterian Health Plan' },
    { value: 'PS4', label: 'PS4 - Presbyterian Health Plan' },
    { value: 'PS5', label: 'PS5 - Presbyterian Health Plan' },
    { value: 'PS6', label: 'PS6 - Presbyterian Health Plan' },
    { value: 'PS1', label: 'PS1 - Presbyterian Health Plan' },
    { value: 'PS2', label: 'PS2 - Presbyterian Health Plan' },
    { value: 'PS3', label: 'PS3 - Presbyterian Health Plan' },
    { value: 'JC1', label: 'JC1 - Aetna Open Access' },
    { value: 'JC2', label: 'JC2 - Aetna Open Access' },
    { value: 'JC3', label: 'JC3 - Aetna Open Access' },
    { value: 'JC4', label: 'JC4 - Aetna Open Access' },
    { value: 'JC5', label: 'JC5 - Aetna Open Access' },
    { value: 'JC6', label: 'JC6 - Aetna Open Access' },
    { value: 'C54', label: 'C54 - Independent Health' },
    { value: 'C55', label: 'C55 - Independent Health' },
    { value: 'C56', label: 'C56 - Independent Health' },
    { value: 'QA1', label: 'QA1 - Independent Health ' },
    { value: 'QA2', label: 'QA2 - Independent Health ' },
    { value: 'QA3', label: 'QA3 - Independent Health ' },
    { value: 'QA4', label: 'QA4 - Independent Health ' },
    { value: 'QA5', label: 'QA5 - Independent Health ' },
    { value: 'QA6', label: 'QA6 - Independent Health ' },
    { value: 'YF1', label: 'YF1 - Medical Mutual of Ohio' },
    { value: 'YF2', label: 'YF2 - Medical Mutual of Ohio' },
    { value: 'YF3', label: 'YF3 - Medical Mutual of Ohio' },
    { value: '644', label: '644 - Medical Mutual of Ohio' },
    { value: '645', label: '645 - Medical Mutual of Ohio' },
    { value: '646', label: '646 - Medical Mutual of Ohio' },
    { value: 'UX1', label: 'UX1 - Medical Mutual of Ohio' },
    { value: 'UX2', label: 'UX2 - Medical Mutual of Ohio' },
    { value: 'UX3', label: 'UX3 - Medical Mutual of Ohio' },
    { value: '574', label: '574 - Kaiser Permanente - Northwest' },
    { value: '575', label: '575 - Kaiser Permanente - Northwest' },
    { value: '576', label: '576 - Kaiser Permanente - Northwest' },
    { value: '571', label: '571 - Kaiser Permanente - Northwest' },
    { value: '572', label: '572 - Kaiser Permanente - Northwest' },
    { value: '573', label: '573 - Kaiser Permanente - Northwest' },
    { value: 'AM1', label: 'AM1 - Kaiser Permanente - Northwest' },
    { value: 'AM2', label: 'AM2 - Kaiser Permanente - Northwest' },
    { value: 'AM3', label: 'AM3 - Kaiser Permanente - Northwest' },
    { value: 'YE1', label: 'YE1 - Aetna Open Access' },
    { value: 'YE2', label: 'YE2 - Aetna Open Access' },
    { value: 'YE3', label: 'YE3 - Aetna Open Access' },
    { value: 'GG4', label: 'GG4 - Geisinger Health Plan' },
    { value: 'GG5', label: 'GG5 - Geisinger Health Plan' },
    { value: 'GG6', label: 'GG6 - Geisinger Health Plan' },
    { value: 'AJ1', label: 'AJ1 - Geisinger Health Plan' },
    { value: 'AJ2', label: 'AJ2 - Geisinger Health Plan' },
    { value: 'AJ3', label: 'AJ3 - Geisinger Health Plan' },
    { value: '8W4', label: '8W4 - UPMC Health Plan ' },
    { value: '8W5', label: '8W5 - UPMC Health Plan ' },
    { value: '8W6', label: '8W6 - UPMC Health Plan ' },
    { value: 'UW4', label: 'UW4 - UPMC Health Plan ' },
    { value: 'UW5', label: 'UW5 - UPMC Health Plan ' },
    { value: 'UW6', label: 'UW6 - UPMC Health Plan ' },
    { value: '891', label: '891 - Triple-S Salud Inc. Puerto Rico' },
    { value: '892', label: '892 - Triple-S Salud Inc. Puerto Rico' },
    { value: '893', label: '893 - Triple-S Salud Inc. Puerto Rico' },
    { value: 'A81', label: 'A81 - Baylor Scott & White Health Plan' },
    { value: 'A82', label: 'A82 - Baylor Scott & White Health Plan' },
    { value: 'A83', label: 'A83 - Baylor Scott & White Health Plan' },
    { value: 'A84', label: 'A84 - Baylor Scott & White Health Plan' },
    { value: 'A85', label: 'A85 - Baylor Scott & White Health Plan' },
    { value: 'A86', label: 'A86 - Baylor Scott & White Health Plan' },
    { value: 'P81', label: 'P81 - Baylor Scott & White Health Plan ' },
    { value: 'P82', label: 'P82 - Baylor Scott & White Health Plan ' },
    { value: 'P83', label: 'P83 - Baylor Scott & White Health Plan ' },
    { value: 'P84', label: 'P84 - Baylor Scott & White Health Plan ' },
    { value: 'P85', label: 'P85 - Baylor Scott & White Health Plan ' },
    { value: 'P86', label: 'P86 - Baylor Scott & White Health Plan ' },
    { value: 'SF4', label: 'SF4 - SelectHealth, Inc.' },
    { value: 'SF5', label: 'SF5 - SelectHealth, Inc.' },
    { value: 'SF6', label: 'SF6 - SelectHealth, Inc.' },
    { value: 'WX1', label: 'WX1 - SelectHealth, Inc.' },
    { value: 'WX2', label: 'WX2 - SelectHealth, Inc.' },
    { value: 'WX3', label: 'WX3 - SelectHealth, Inc.' },
    { value: '851', label: '851 - Triple-S Salud Inc. U.S. Virgin Islands' },
    { value: '852', label: '852 - Triple-S Salud Inc. U.S. Virgin Islands' },
    { value: '853', label: '853 - Triple-S Salud Inc. U.S. Virgin Islands' },
    { value: 'F21', label: 'F21 - Sentara Health Plans' },
    { value: 'F22', label: 'F22 - Sentara Health Plans' },
    { value: 'F23', label: 'F23 - Sentara Health Plans' },
    { value: 'PG4', label: 'PG4 - Sentara Health Plans' },
    { value: 'PG5', label: 'PG5 - Sentara Health Plans' },
    { value: 'PG6', label: 'PG6 - Sentara Health Plans' },
    { value: 'PG1', label: 'PG1 - Sentara Health Plans' },
    { value: 'PG2', label: 'PG2 - Sentara Health Plans' },
    { value: 'PG3', label: 'PG3 - Sentara Health Plans' },
    {
      value: 'L11',
      label: 'L11 - Kaiser Permanente Washington Options Federal ',
    },
    {
      value: 'L12',
      label: 'L12 - Kaiser Permanente Washington Options Federal ',
    },
    {
      value: 'L13',
      label: 'L13 - Kaiser Permanente Washington Options Federal ',
    },
    {
      value: 'L14',
      label: 'L14 - Kaiser Permanente Washington Options Federal ',
    },
    {
      value: 'L15',
      label: 'L15 - Kaiser Permanente Washington Options Federal ',
    },
    {
      value: 'L16',
      label: 'L16 - Kaiser Permanente Washington Options Federal ',
    },
    {
      value: 'WJ1',
      label: 'WJ1 - Group Health Cooperative of South Central Wisconsin',
    },
    {
      value: 'WJ2',
      label: 'WJ2 - Group Health Cooperative of South Central Wisconsin',
    },
    {
      value: 'WJ3',
      label: 'WJ3 - Group Health Cooperative of South Central Wisconsin',
    },
    {
      value: 'WJ4',
      label: 'WJ4 - Group Health Cooperative of South Central Wisconsin',
    },
    {
      value: 'WJ5',
      label: 'WJ5 - Group Health Cooperative of South Central Wisconsin',
    },
    {
      value: 'WJ6',
      label: 'WJ6 - Group Health Cooperative of South Central Wisconsin',
    },
    { value: '474', label: '474 - APWU Health Plan ' },
    { value: '475', label: '475 - APWU Health Plan ' },
    { value: '476', label: '476 - APWU Health Plan ' },
    { value: '471', label: '471 - APWU Health Plan ' },
    { value: '472', label: '472 - APWU Health Plan ' },
    { value: '473', label: '473 - APWU Health Plan ' },
    {
      value: '111',
      label: '111 - Blue Cross and Blue Shield Service Benefit Plan FEP Basic',
    },
    {
      value: '112',
      label: '112 - Blue Cross and Blue Shield Service Benefit Plan FEP Basic',
    },
    {
      value: '113',
      label: '113 - Blue Cross and Blue Shield Service Benefit Plan FEP Basic',
    },
    {
      value: '131',
      label:
        '131 - Blue Cross and Blue Shield Service Benefit Plan FEP Blue Focus',
    },
    {
      value: '132',
      label:
        '132 - Blue Cross and Blue Shield Service Benefit Plan FEP Blue Focus',
    },
    {
      value: '133',
      label:
        '133 - Blue Cross and Blue Shield Service Benefit Plan FEP Blue Focus',
    },
    {
      value: '104',
      label:
        '104 - Blue Cross and Blue Shield Service Benefit Plan FEP Blue Standard',
    },
    {
      value: '105',
      label:
        '105 - Blue Cross and Blue Shield Service Benefit Plan FEP Blue Standard',
    },
    {
      value: '106',
      label:
        '106 - Blue Cross and Blue Shield Service Benefit Plan FEP Blue Standard',
    },
    { value: '421', label: '421 - Compass Rose Health Plan' },
    { value: '422', label: '422 - Compass Rose Health Plan' },
    { value: '423', label: '423 - Compass Rose Health Plan' },
    { value: '424', label: '424 - Compass Rose Health Plan' },
    { value: '425', label: '425 - Compass Rose Health Plan' },
    { value: '426', label: '426 - Compass Rose Health Plan' },
    { value: '401', label: '401 - Foreign Service Benefit Plan ' },
    { value: '402', label: '402 - Foreign Service Benefit Plan ' },
    { value: '403', label: '403 - Foreign Service Benefit Plan ' },
    { value: '311', label: '311 - GEHA Benefit Plan' },
    { value: '312', label: '312 - GEHA Benefit Plan' },
    { value: '313', label: '313 - GEHA Benefit Plan' },
    { value: '314', label: '314 - GEHA Benefit Plan' },
    { value: '315', label: '315 - GEHA Benefit Plan' },
    { value: '316', label: '316 - GEHA Benefit Plan' },
    { value: '341', label: '341 - GEHA HDHP' },
    { value: '342', label: '342 - GEHA HDHP' },
    { value: '343', label: '343 - GEHA HDHP' },
    { value: '251', label: '251 - GEHA Indemnity Benefit Plan' },
    { value: '252', label: '252 - GEHA Indemnity Benefit Plan' },
    { value: '253', label: '253 - GEHA Indemnity Benefit Plan' },
    { value: '254', label: '254 - GEHA Indemnity Benefit Plan' },
    { value: '255', label: '255 - GEHA Indemnity Benefit Plan' },
    { value: '256', label: '256 - GEHA Indemnity Benefit Plan' },
    { value: '481', label: '481 - MHBP Consumer Option' },
    { value: '482', label: '482 - MHBP Consumer Option' },
    { value: '483', label: '483 - MHBP Consumer Option' },
    { value: '454', label: '454 - MHBP Standard Option' },
    { value: '455', label: '455 - MHBP Standard Option' },
    { value: '456', label: '456 - MHBP Standard Option' },
    { value: '414', label: '414 - MHBP Value Plan' },
    { value: '415', label: '415 - MHBP Value Plan' },
    { value: '416', label: '416 - MHBP Value Plan' },
    { value: '324', label: '324 - NALC Health Benefit Plan ' },
    { value: '325', label: '325 - NALC Health Benefit Plan ' },
    { value: '326', label: '326 - NALC Health Benefit Plan ' },
    { value: '321', label: '321 - NALC Health Benefit Plan ' },
    { value: '322', label: '322 - NALC Health Benefit Plan ' },
    { value: '323', label: '323 - NALC Health Benefit Plan ' },
    { value: '431', label: '431 - Panama Canal Area Benefit Plan' },
    { value: '432', label: '432 - Panama Canal Area Benefit Plan' },
    { value: '433', label: '433 - Panama Canal Area Benefit Plan' },
    { value: '441', label: '441 - SAMBA Health Benefit Plan' },
    { value: '442', label: '442 - SAMBA Health Benefit Plan' },
    { value: '443', label: '443 - SAMBA Health Benefit Plan' },
    { value: '444', label: '444 - SAMBA Health Benefit Plan' },
    { value: '445', label: '445 - SAMBA Health Benefit Plan' },
    { value: '446', label: '446 - SAMBA Health Benefit Plan' },
    {
      value: 'L7A',
      label: 'L7A - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'L7B',
      label: 'L7B - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'L7C',
      label: 'L7C - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'L7D',
      label: 'L7D - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'L7E',
      label: 'L7E - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'L7F',
      label: 'L7F - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'HLD',
      label:
        'HLD - Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Advantage',
    },
    {
      value: 'HLE',
      label:
        'HLE - Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Advantage',
    },
    {
      value: 'HLF',
      label:
        'HLF - Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Advantage',
    },
    {
      value: 'G3A',
      label:
        'G3A - Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Direct and HDHP',
    },
    {
      value: 'G3B',
      label:
        'G3B - Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Direct and HDHP',
    },
    {
      value: 'G3C',
      label:
        'G3C - Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Direct and HDHP',
    },
    {
      value: 'G3D',
      label:
        'G3D - Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Direct and HDHP',
    },
    {
      value: 'G3E',
      label:
        'G3E - Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Direct and HDHP',
    },
    {
      value: 'G3F',
      label:
        'G3F - Aetna: HDHP, Aetna Direct, Aetna Advantage - Aetna Direct and HDHP',
    },
    {
      value: 'JYA',
      label:
        'JYA - UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary Postal East - Choice Plus Primary Postal East',
    },
    {
      value: 'JYB',
      label:
        'JYB - UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary Postal East - Choice Plus Primary Postal East',
    },
    {
      value: 'JYC',
      label:
        'JYC - UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary Postal East - Choice Plus Primary Postal East',
    },
    {
      value: 'JDA',
      label: 'JDA - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'JDB',
      label: 'JDB - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'JDC',
      label: 'JDC - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'JDD',
      label: 'JDD - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'JDE',
      label: 'JDE - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'JDF',
      label: 'JDF - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'GRA',
      label: 'GRA - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'GRB',
      label: 'GRB - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'GRC',
      label: 'GRC - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'GRD',
      label: 'GRD - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'GRE',
      label: 'GRE - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'GRF',
      label: 'GRF - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'KEA',
      label:
        'KEA - UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary Postal West - Choice Plus Primary Postal West',
    },
    {
      value: 'KEB',
      label:
        'KEB - UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary Postal West - Choice Plus Primary Postal West',
    },
    {
      value: 'KEC',
      label:
        'KEC - UnitedHealthcare Insurance Company, Inc. - Choice Plus Primary Postal West - Choice Plus Primary Postal West',
    },
    {
      value: 'NNA',
      label:
        'NNA - Kaiser Permanente - Fresno California - High and Standard Option',
    },
    {
      value: 'NNB',
      label:
        'NNB - Kaiser Permanente - Fresno California - High and Standard Option',
    },
    {
      value: 'NNC',
      label:
        'NNC - Kaiser Permanente - Fresno California - High and Standard Option',
    },
    {
      value: 'NND',
      label:
        'NND - Kaiser Permanente - Fresno California - High and Standard Option',
    },
    {
      value: 'NNE',
      label:
        'NNE - Kaiser Permanente - Fresno California - High and Standard Option',
    },
    {
      value: 'NNF',
      label:
        'NNF - Kaiser Permanente - Fresno California - High and Standard Option',
    },
    {
      value: 'TBA',
      label:
        'TBA - Kaiser Permanente - Northern California - High and Standard Option',
    },
    {
      value: 'TBB',
      label:
        'TBB - Kaiser Permanente - Northern California - High and Standard Option',
    },
    {
      value: 'TBC',
      label:
        'TBC - Kaiser Permanente - Northern California - High and Standard Option',
    },
    {
      value: 'TBD',
      label:
        'TBD - Kaiser Permanente - Northern California - High and Standard Option',
    },
    {
      value: 'TBE',
      label:
        'TBE - Kaiser Permanente - Northern California - High and Standard Option',
    },
    {
      value: 'TBF',
      label:
        'TBF - Kaiser Permanente - Northern California - High and Standard Option',
    },
    {
      value: 'UDA',
      label: 'UDA - Kaiser Permanente - Northern California - Prosper',
    },
    {
      value: 'UDB',
      label: 'UDB - Kaiser Permanente - Northern California - Prosper',
    },
    {
      value: 'UDC',
      label: 'UDC - Kaiser Permanente - Northern California - Prosper',
    },
    {
      value: 'Y3A',
      label:
        'Y3A - Kaiser Permanente - Southern California - High and Standard Option',
    },
    {
      value: 'Y3B',
      label:
        'Y3B - Kaiser Permanente - Southern California - High and Standard Option',
    },
    {
      value: 'Y3C',
      label:
        'Y3C - Kaiser Permanente - Southern California - High and Standard Option',
    },
    {
      value: 'Y3D',
      label:
        'Y3D - Kaiser Permanente - Southern California - High and Standard Option',
    },
    {
      value: 'Y3E',
      label:
        'Y3E - Kaiser Permanente - Southern California - High and Standard Option',
    },
    {
      value: 'Y3F',
      label:
        'Y3F - Kaiser Permanente - Southern California - High and Standard Option',
    },
    {
      value: 'MBA',
      label: 'MBA - Kaiser Permanente - Southern California - Prosper',
    },
    {
      value: 'MBB',
      label: 'MBB - Kaiser Permanente - Southern California - Prosper',
    },
    {
      value: 'MBC',
      label: 'MBC - Kaiser Permanente - Southern California - Prosper',
    },
    {
      value: 'M8A',
      label: 'M8A - Kaiser Permanente - Colorado - High and Standard Option',
    },
    {
      value: 'M8B',
      label: 'M8B - Kaiser Permanente - Colorado - High and Standard Option',
    },
    {
      value: 'M8C',
      label: 'M8C - Kaiser Permanente - Colorado - High and Standard Option',
    },
    {
      value: 'M8D',
      label: 'M8D - Kaiser Permanente - Colorado - High and Standard Option',
    },
    {
      value: 'M8E',
      label: 'M8E - Kaiser Permanente - Colorado - High and Standard Option',
    },
    {
      value: 'M8F',
      label: 'M8F - Kaiser Permanente - Colorado - High and Standard Option',
    },
    { value: 'NCA', label: 'NCA - Kaiser Permanente - Colorado - Prosper' },
    { value: 'NCB', label: 'NCB - Kaiser Permanente - Colorado - Prosper' },
    { value: 'NCC', label: 'NCC - Kaiser Permanente - Colorado - Prosper' },
    {
      value: 'KDA',
      label: 'KDA - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'KDB',
      label: 'KDB - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'KDC',
      label: 'KDC - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'KDD',
      label: 'KDD - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'KDE',
      label: 'KDE - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'KDF',
      label: 'KDF - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'HXD',
      label: 'HXD - Aetna: Open Access HMO and Aetna Saver - Aetna Saver',
    },
    {
      value: 'HXE',
      label: 'HXE - Aetna: Open Access HMO and Aetna Saver - Aetna Saver',
    },
    {
      value: 'HXF',
      label: 'HXF - Aetna: Open Access HMO and Aetna Saver - Aetna Saver',
    },
    {
      value: 'G8A',
      label:
        'G8A - Aetna: Open Access HMO and Aetna Saver - Open Access - Basic and High Option',
    },
    {
      value: 'G8B',
      label:
        'G8B - Aetna: Open Access HMO and Aetna Saver - Open Access - Basic and High Option',
    },
    {
      value: 'G8C',
      label:
        'G8C - Aetna: Open Access HMO and Aetna Saver - Open Access - Basic and High Option',
    },
    {
      value: 'G8D',
      label:
        'G8D - Aetna: Open Access HMO and Aetna Saver - Open Access - Basic and High Option',
    },
    {
      value: 'G8E',
      label:
        'G8E - Aetna: Open Access HMO and Aetna Saver - Open Access - Basic and High Option',
    },
    {
      value: 'G8F',
      label:
        'G8F - Aetna: Open Access HMO and Aetna Saver - Open Access - Basic and High Option',
    },
    {
      value: 'K4A',
      label: 'K4A - CAREFIRST BLUECHOICE, INC. - CareFirst BlueChoice, Inc.',
    },
    {
      value: 'K4B',
      label: 'K4B - CAREFIRST BLUECHOICE, INC. - CareFirst BlueChoice, Inc.',
    },
    {
      value: 'K4C',
      label: 'K4C - CAREFIRST BLUECHOICE, INC. - CareFirst BlueChoice, Inc.',
    },
    {
      value: 'K4D',
      label: 'K4D - CAREFIRST BLUECHOICE, INC. - CareFirst BlueChoice, Inc.',
    },
    {
      value: 'K4E',
      label: 'K4E - CAREFIRST BLUECHOICE, INC. - CareFirst BlueChoice, Inc.',
    },
    {
      value: 'K4F',
      label: 'K4F - CAREFIRST BLUECHOICE, INC. - CareFirst BlueChoice, Inc.',
    },
    {
      value: 'RAA',
      label:
        'RAA - Kaiser Permanente - Mid-Atlantic States - High and Standard Option',
    },
    {
      value: 'RAB',
      label:
        'RAB - Kaiser Permanente - Mid-Atlantic States - High and Standard Option',
    },
    {
      value: 'RAC',
      label:
        'RAC - Kaiser Permanente - Mid-Atlantic States - High and Standard Option',
    },
    {
      value: 'RAD',
      label:
        'RAD - Kaiser Permanente - Mid-Atlantic States - High and Standard Option',
    },
    {
      value: 'RAE',
      label:
        'RAE - Kaiser Permanente - Mid-Atlantic States - High and Standard Option',
    },
    {
      value: 'RAF',
      label:
        'RAF - Kaiser Permanente - Mid-Atlantic States - High and Standard Option',
    },
    {
      value: 'NWA',
      label: 'NWA - Kaiser Permanente - Mid-Atlantic States - Prosper',
    },
    {
      value: 'NWB',
      label: 'NWB - Kaiser Permanente - Mid-Atlantic States - Prosper',
    },
    {
      value: 'NWC',
      label: 'NWC - Kaiser Permanente - Mid-Atlantic States - Prosper',
    },
    {
      value: 'PFA',
      label: 'PFA - Kaiser Permanente - Georgia - High and Standard Option',
    },
    {
      value: 'PFB',
      label: 'PFB - Kaiser Permanente - Georgia - High and Standard Option',
    },
    {
      value: 'PFC',
      label: 'PFC - Kaiser Permanente - Georgia - High and Standard Option',
    },
    {
      value: 'PFD',
      label: 'PFD - Kaiser Permanente - Georgia - High and Standard Option',
    },
    {
      value: 'PFE',
      label: 'PFE - Kaiser Permanente - Georgia - High and Standard Option',
    },
    {
      value: 'PFF',
      label: 'PFF - Kaiser Permanente - Georgia - High and Standard Option',
    },
    { value: 'QZA', label: 'QZA - Kaiser Permanente - Georgia - Prosper' },
    { value: 'QZB', label: 'QZB - Kaiser Permanente - Georgia - Prosper' },
    { value: 'QZC', label: 'QZC - Kaiser Permanente - Georgia - Prosper' },
    {
      value: 'HJA',
      label:
        'HJA - TakeCare Insurance Company, Inc. - TakeCare HDHP PSHB Option',
    },
    {
      value: 'HJB',
      label:
        'HJB - TakeCare Insurance Company, Inc. - TakeCare HDHP PSHB Option',
    },
    {
      value: 'HJC',
      label:
        'HJC - TakeCare Insurance Company, Inc. - TakeCare HDHP PSHB Option',
    },
    {
      value: 'G4A',
      label:
        'G4A - TakeCare Insurance Company, Inc. - TakeCare High and Standard PSHB Options',
    },
    {
      value: 'G4B',
      label:
        'G4B - TakeCare Insurance Company, Inc. - TakeCare High and Standard PSHB Options',
    },
    {
      value: 'G4C',
      label:
        'G4C - TakeCare Insurance Company, Inc. - TakeCare High and Standard PSHB Options',
    },
    {
      value: 'G4D',
      label:
        'G4D - TakeCare Insurance Company, Inc. - TakeCare High and Standard PSHB Options',
    },
    {
      value: 'G4E',
      label:
        'G4E - TakeCare Insurance Company, Inc. - TakeCare High and Standard PSHB Options',
    },
    {
      value: 'G4F',
      label:
        'G4F - TakeCare Insurance Company, Inc. - TakeCare High and Standard PSHB Options',
    },
    {
      value: 'M6A',
      label: 'M6A - HMSA Plan - HMSA Plan for Postal Service Employees',
    },
    {
      value: 'M6B',
      label: 'M6B - HMSA Plan - HMSA Plan for Postal Service Employees',
    },
    {
      value: 'M6C',
      label: 'M6C - HMSA Plan - HMSA Plan for Postal Service Employees',
    },
    {
      value: 'M6D',
      label: 'M6D - HMSA Plan - HMSA Plan for Postal Service Employees',
    },
    {
      value: 'M6E',
      label: 'M6E - HMSA Plan - HMSA Plan for Postal Service Employees',
    },
    {
      value: 'M6F',
      label: 'M6F - HMSA Plan - HMSA Plan for Postal Service Employees',
    },
    {
      value: 'PKA',
      label: 'PKA - Kaiser Permanente - Hawaii - High and Standard Option',
    },
    {
      value: 'PKB',
      label: 'PKB - Kaiser Permanente - Hawaii - High and Standard Option',
    },
    {
      value: 'PKC',
      label: 'PKC - Kaiser Permanente - Hawaii - High and Standard Option',
    },
    {
      value: 'PKD',
      label: 'PKD - Kaiser Permanente - Hawaii - High and Standard Option',
    },
    {
      value: 'PKE',
      label: 'PKE - Kaiser Permanente - Hawaii - High and Standard Option',
    },
    {
      value: 'PKF',
      label: 'PKF - Kaiser Permanente - Hawaii - High and Standard Option',
    },
    {
      value: 'HHA',
      label: 'HHA - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'HHB',
      label: 'HHB - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'HHC',
      label: 'HHC - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'HHD',
      label: 'HHD - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'HHE',
      label: 'HHE - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'HHF',
      label: 'HHF - Aetna: CDHP and Value - Aetna CDHP and Value Plan',
    },
    {
      value: 'DWD',
      label: 'DWD - Kaiser Permanente - Washington Core - Washington Core',
    },
    {
      value: 'DWE',
      label: 'DWE - Kaiser Permanente - Washington Core - Washington Core',
    },
    {
      value: 'DWF',
      label: 'DWF - Kaiser Permanente - Washington Core - Washington Core',
    },
    {
      value: 'PRA',
      label: 'PRA - Kaiser Permanente - Washington Core - Washington Core',
    },
    {
      value: 'PRB',
      label: 'PRB - Kaiser Permanente - Washington Core - Washington Core',
    },
    {
      value: 'PRC',
      label: 'PRC - Kaiser Permanente - Washington Core - Washington Core',
    },
    {
      value: 'PRD',
      label: 'PRD - Kaiser Permanente - Washington Core - Washington Core',
    },
    {
      value: 'PRE',
      label: 'PRE - Kaiser Permanente - Washington Core - Washington Core',
    },
    {
      value: 'PRF',
      label: 'PRF - Kaiser Permanente - Washington Core - Washington Core',
    },
    {
      value: 'KGA',
      label: 'KGA - HealthPartners - HealthPartners High/Standard Option',
    },
    {
      value: 'KGB',
      label: 'KGB - HealthPartners - HealthPartners High/Standard Option',
    },
    {
      value: 'KGC',
      label: 'KGC - HealthPartners - HealthPartners High/Standard Option',
    },
    {
      value: 'KGD',
      label: 'KGD - HealthPartners - HealthPartners High/Standard Option',
    },
    {
      value: 'KGE',
      label: 'KGE - HealthPartners - HealthPartners High/Standard Option',
    },
    {
      value: 'KGF',
      label: 'KGF - HealthPartners - HealthPartners High/Standard Option',
    },
    {
      value: 'J5A',
      label: 'J5A - Health Alliance Plan of Michigan - PSHB  High & Standard',
    },
    {
      value: 'J5B',
      label: 'J5B - Health Alliance Plan of Michigan - PSHB  High & Standard',
    },
    {
      value: 'J5C',
      label: 'J5C - Health Alliance Plan of Michigan - PSHB  High & Standard',
    },
    {
      value: 'J5D',
      label: 'J5D - Health Alliance Plan of Michigan - PSHB  High & Standard',
    },
    {
      value: 'J5E',
      label: 'J5E - Health Alliance Plan of Michigan - PSHB  High & Standard',
    },
    {
      value: 'J5F',
      label: 'J5F - Health Alliance Plan of Michigan - PSHB  High & Standard',
    },
    {
      value: 'D3A',
      label: 'D3A - Medical Mutual of Ohio - PSHB - Standard & Basic Option',
    },
    {
      value: 'D3B',
      label: 'D3B - Medical Mutual of Ohio - PSHB - Standard & Basic Option',
    },
    {
      value: 'D3C',
      label: 'D3C - Medical Mutual of Ohio - PSHB - Standard & Basic Option',
    },
    {
      value: 'D3D',
      label: 'D3D - Medical Mutual of Ohio - PSHB - Standard & Basic Option',
    },
    {
      value: 'D3E',
      label: 'D3E - Medical Mutual of Ohio - PSHB - Standard & Basic Option',
    },
    {
      value: 'D3F',
      label: 'D3F - Medical Mutual of Ohio - PSHB - Standard & Basic Option',
    },
    {
      value: 'UZA',
      label: 'UZA - Kaiser Permanente - Northwest - High and Standard Option',
    },
    {
      value: 'UZB',
      label: 'UZB - Kaiser Permanente - Northwest - High and Standard Option',
    },
    {
      value: 'UZC',
      label: 'UZC - Kaiser Permanente - Northwest - High and Standard Option',
    },
    {
      value: 'UZD',
      label: 'UZD - Kaiser Permanente - Northwest - High and Standard Option',
    },
    {
      value: 'UZE',
      label: 'UZE - Kaiser Permanente - Northwest - High and Standard Option',
    },
    {
      value: 'UZF',
      label: 'UZF - Kaiser Permanente - Northwest - High and Standard Option',
    },
    { value: 'YRA', label: 'YRA - Kaiser Permanente - Northwest - Prosper' },
    { value: 'YRB', label: 'YRB - Kaiser Permanente - Northwest - Prosper' },
    { value: 'YRC', label: 'YRC - Kaiser Permanente - Northwest - Prosper' },
    { value: 'G9A', label: 'G9A - UPMC Health Plan - UPMC Health Plan' },
    { value: 'G9B', label: 'G9B - UPMC Health Plan - UPMC Health Plan' },
    { value: 'G9C', label: 'G9C - UPMC Health Plan - UPMC Health Plan' },
    { value: 'G9D', label: 'G9D - UPMC Health Plan - UPMC Health Plan' },
    { value: 'G9E', label: 'G9E - UPMC Health Plan - UPMC Health Plan' },
    { value: 'G9F', label: 'G9F - UPMC Health Plan - UPMC Health Plan' },
    { value: '83A', label: '83A - Triple-S Salud, Inc - Triple-S Salud' },
    { value: '83B', label: '83B - Triple-S Salud, Inc - Triple-S Salud' },
    { value: '83C', label: '83C - Triple-S Salud, Inc - Triple-S Salud' },
    { value: '14A', label: '14A - Triple-S Salud, Inc - Triple-S Salud' },
    { value: '14B', label: '14B - Triple-S Salud, Inc - Triple-S Salud' },
    { value: '14C', label: '14C - Triple-S Salud, Inc - Triple-S Salud' },
    {
      value: 'H9A',
      label:
        'H9A - Kaiser Permanente Washington Options Federal - Standard and HDHP',
    },
    {
      value: 'H9B',
      label:
        'H9B - Kaiser Permanente Washington Options Federal - Standard and HDHP',
    },
    {
      value: 'H9C',
      label:
        'H9C - Kaiser Permanente Washington Options Federal - Standard and HDHP',
    },
    {
      value: 'H9D',
      label:
        'H9D - Kaiser Permanente Washington Options Federal - Standard and HDHP',
    },
    {
      value: 'H9E',
      label:
        'H9E - Kaiser Permanente Washington Options Federal - Standard and HDHP',
    },
    {
      value: 'H9F',
      label:
        'H9F - Kaiser Permanente Washington Options Federal - Standard and HDHP',
    },
    { value: '23A', label: '23A - APWU Health Plan' },
    { value: '23B', label: '23B - APWU Health Plan' },
    { value: '23C', label: '23C - APWU Health Plan' },
    { value: '23D', label: '23D - APWU Health Plan' },
    { value: '23E', label: '23E - APWU Health Plan' },
    { value: '23F', label: '23F - APWU Health Plan' },
    {
      value: '33A',
      label: '33A - Blue Cross and Blue Shield Service Benefit Plan',
    },
    {
      value: '33B',
      label: '33B - Blue Cross and Blue Shield Service Benefit Plan',
    },
    {
      value: '33C',
      label: '33C - Blue Cross and Blue Shield Service Benefit Plan',
    },
    {
      value: '33D',
      label: '33D - Blue Cross and Blue Shield Service Benefit Plan',
    },
    {
      value: '33E',
      label: '33E - Blue Cross and Blue Shield Service Benefit Plan',
    },
    {
      value: '33F',
      label: '33F - Blue Cross and Blue Shield Service Benefit Plan',
    },
    {
      value: '35A',
      label:
        '35A - Blue Cross and Blue Shield Service Benefit Plan FEP Blue Focus',
    },
    {
      value: '35B',
      label:
        '35B - Blue Cross and Blue Shield Service Benefit Plan FEP Blue Focus',
    },
    {
      value: '35C',
      label:
        '35C - Blue Cross and Blue Shield Service Benefit Plan FEP Blue Focus',
    },
    { value: '39A', label: '39A - GEHA Benefit Plan - HDHP' },
    { value: '39B', label: '39B - GEHA Benefit Plan - HDHP' },
    { value: '39C', label: '39C - GEHA Benefit Plan - HDHP' },
    { value: '37A', label: '37A - GEHA Benefit Plan - High and Standard' },
    { value: '37B', label: '37B - GEHA Benefit Plan - High and Standard' },
    { value: '37C', label: '37C - GEHA Benefit Plan - High and Standard' },
    { value: '37D', label: '37D - GEHA Benefit Plan - High and Standard' },
    { value: '37E', label: '37E - GEHA Benefit Plan - High and Standard' },
    { value: '37F', label: '37F - GEHA Benefit Plan - High and Standard' },
    { value: '58A', label: '58A - GEHA Indemnity - Elevate Plus and Elevate' },
    { value: '58B', label: '58B - GEHA Indemnity - Elevate Plus and Elevate' },
    { value: '58C', label: '58C - GEHA Indemnity - Elevate Plus and Elevate' },
    { value: '58D', label: '58D - GEHA Indemnity - Elevate Plus and Elevate' },
    { value: '58E', label: '58E - GEHA Indemnity - Elevate Plus and Elevate' },
    { value: '58F', label: '58F - GEHA Indemnity - Elevate Plus and Elevate' },
    { value: '74A', label: '74A - MHBP Consumer Option' },
    { value: '74B', label: '74B - MHBP Consumer Option' },
    { value: '74C', label: '74C - MHBP Consumer Option' },
    { value: '73A', label: '73A - MHBP Standard and Value Option' },
    { value: '73B', label: '73B - MHBP Standard and Value Option' },
    { value: '73C', label: '73C - MHBP Standard and Value Option' },
    { value: '73D', label: '73D - MHBP Standard and Value Option' },
    { value: '73E', label: '73E - MHBP Standard and Value Option' },
    { value: '73F', label: '73F - MHBP Standard and Value Option' },
    { value: '77A', label: '77A - NALC Health Benefit Plan' },
    { value: '77B', label: '77B - NALC Health Benefit Plan' },
    { value: '77C', label: '77C - NALC Health Benefit Plan' },
    { value: '77D', label: '77D - NALC Health Benefit Plan' },
    { value: '77E', label: '77E - NALC Health Benefit Plan' },
    { value: '77F', label: '77F - NALC Health Benefit Plan' },
    { value: '79A', label: '79A - Rural Carrier Benefit Plan' },
    { value: '79B', label: '79B - Rural Carrier Benefit Plan' },
    { value: '79C', label: '79C - Rural Carrier Benefit Plan' },
  ],
  deductionTypes: [
    { value: 'fdvd', label: 'FDV-D' },
    { value: 'fdvv', label: 'FDV-V' },
    { value: 'ltc', label: 'LTC' },
    { value: 'uniondues', label: 'Union Dues' },
    { value: 'charity', label: 'Charity' },
    { value: 'alotsavings', label: 'ALOT - Savings' },
    { value: 'alotchecking', label: 'ALOT - Checking' },
    { value: 'alotother', label: 'ALOT - Other' },
    { value: 'extratax', label: 'Extra Tax' },
    { value: 'fsa', label: 'FSA' },
    { value: 'visiondental', label: 'Vision/Dental' },
    { value: 'vbp', label: 'VBP' },
    { value: 'hsa', label: 'HSA' },
  ],
  unionAffiliation: [
    {
      value: 'americanfederationofgovernmentemployees-afge',
      label: 'American Federation of Government Employees (AFGE)',
    },
    {
      value: 'americanpostalworkersunion-apwu',
      label: 'American Postal Workers Union (APWU)',
    },
    {
      value: 'nationalallianceofpostalandfederalemployees-napfe',
      label: 'National Alliance of Postal and Federal Employees (NAPFE)',
    },
    {
      value: 'nationalassociationoflettercarriers-nalc',
      label: 'National Association of Letter Carriers (NALC)',
    },
    {
      value: 'nationalassociationofpostalsupervisors-naps',
      label: 'National Association of Postal Supervisors (NAPS)',
    },
    {
      value: 'nationalpostalmailhandlersunion-npmhu',
      label: 'National Postal Mail Handlers Union (NPMHU)',
    },
    {
      value: 'nationalrurallettercarriersassociation-nrlca',
      label: "National Rural Letter Carriers' Association (NRLCA)",
    },
    {
      value: 'nationaltreasuryemployeesunion-nteu',
      label: 'National Treasury Employees Union (NTEU)',
    },
  ],
  appointmentTypes: [
    {
      value: 'federal-consultation',
      label: 'Federal Consultation - 120min',
      type: 'Federal Consultation',
      duration: 120,
    },
    {
      value: 'retirement-consultation',
      label: 'Retirement Consultation - 120min',
      type: 'Retirement Consultation',
      duration: 120,
    },
    {
      value: 'financial-framework',
      label: 'Financial Framework - 120min',
      type: 'Financial Framework',
      duration: 120,
    },
    {
      value: 'continued-financial-framework',
      label: 'Continued Financial Framework - 60min',
      type: 'Continued Financial Framework',
      duration: 60,
    },
    {
      value: 'continued-retirement-consultation',
      label: 'Continued Retirement Consultation - 60min',
      type: 'Continued Retirement Consultation',
      duration: 60,
    },
    {
      value: 'csrs-consultation',
      label: 'CSRS Consultation - 60min',
      type: 'CSRS Consultation',
      duration: 60,
    },
    {
      value: 'disability-retirement-consultation',
      label: 'Disability Retirement Consultation - 60min',
      type: 'Disability Retirement Consultation',
      duration: 60,
    },
    {
      value: 'estate-planning',
      label: 'Estate Planning - 60min',
      type: 'Estate Planning',
      duration: 60,
    },
    {
      value: 'fegli-change-form-review',
      label: 'FEGLI Change Form Review - 60min',
      type: 'FEGLI Change Form Review',
      duration: 60,
    },
    {
      value: 'fers-consultation',
      label: 'FERS Consultation - 60min',
      type: 'FERS Consultation',
      duration: 60,
    },
    {
      value: 'life-insurance-consultation',
      label: 'Life Insurance Consultation - 60min',
      type: 'Life Insurance Consultation',
      duration: 60,
    },
    {
      value: 'medicare-enrollment',
      label: 'Medicare Enrollment - 60min',
      type: 'Medicare Enrollment',
      duration: 60,
    },
    {
      value: 'military-buyback-review',
      label: 'Military Buyback Review - 60min',
      type: 'Military Buyback Review',
      duration: 60,
    },
    {
      value: 'mortgage-pre-qualifying',
      label: 'Mortgage Pre-Qualifying - 60min',
      type: 'Mortgage Pre-Qualifying',
      duration: 60,
    },
    {
      value: 'mortgage-refinancing',
      label: 'Mortgage Refinancing - 60min',
      type: 'Mortgage Refinancing',
      duration: 60,
    },
    {
      value: 'onboarding',
      label: 'Onboarding - 60min',
      type: 'Onboarding',
      duration: 60,
    },
    {
      value: 'paperwork',
      label: 'Paperwork - 60min',
      type: 'Paperwork',
      duration: 60,
    },
    {
      value: 'plan-recommendation',
      label: 'Plan Recommendation - 60min',
      type: 'Plan Recommendation',
      duration: 60,
    },
    {
      value: 'platform-review',
      label: 'Platform Review - 60min',
      type: 'Platform Review',
      duration: 60,
    },
    {
      value: 'portfolio-review',
      label: 'Portfolio Review - 60min',
      type: 'Portfolio Review',
      duration: 60,
    },
    {
      value: 'retirement-paperwork',
      label: 'Retirement Paperwork - 60min',
      type: 'Retirement Paperwork',
      duration: 60,
    },
    {
      value: 'risk-analysis',
      label: 'Risk Analysis - 60min',
      type: 'Risk Analysis',
      duration: 60,
    },
    {
      value: 'risk-assessment',
      label: 'Risk Assessment - 60min',
      type: 'Risk Assessment',
      duration: 60,
    },
    {
      value: 'social-security-enrollment',
      label: 'Social Security Enrollment - 60min',
      type: 'Social Security Enrollment',
      duration: 60,
    },
    {
      value: 'tax-accounting-consultation',
      label: 'Tax Accounting Consultation - 60min',
      type: 'Tax Accounting Consultation',
      duration: 60,
    },
    {
      value: 'wealth-management',
      label: 'Wealth Management - 60min',
      type: 'Wealth Management',
      duration: 60,
    },
    {
      value: 'wealth-management-introduction',
      label: 'Wealth Management Introduction - 60min',
      type: 'Wealth Management Introduction',
      duration: 60,
    },
    {
      value: '',
      label: '--------------',
      type: '--------------',
      duration: 60,
    },
    {
      value: 'in-person-appointment',
      label: 'In-Person Appointment - 60min',
      type: 'In-Person Appointment',
      duration: 60,
    },
    {
      value: 'key-action-items',
      label: 'Key Action Items - 60min',
      type: 'Key Action Items',
      duration: 60,
    },
    {
      value: 'magic-meeting-discovery',
      label: 'Magic Meeting Discovery - 60min',
      type: 'Magic Meeting Discovery',
      duration: 60,
    },
    {
      value: 'requested-call-back',
      label: 'Requested Call Back - 60min',
      type: 'Requested Call Back',
      duration: 60,
    },
  ],
  states: [
    {
      value: '',
      label: '',
      abbr: '',
      logo: '',
    },
    {
      value: 'alabama',
      label: 'Alabama',
      abbr: 'AL',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_Alabama.svg',
    },
    {
      value: 'alaska',
      label: 'Alaska',
      abbr: 'AK',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/e/e6/Flag_of_Alaska.svg',
    },
    {
      value: 'arizona',
      label: 'Arizona',
      abbr: 'AZ',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/9/9d/Flag_of_Arizona.svg',
    },
    {
      value: 'arkansas',
      label: 'Arkansas',
      abbr: 'AR',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/9/9d/Flag_of_Arkansas.svg',
    },
    {
      value: 'california',
      label: 'California',
      abbr: 'CA',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/0/01/Flag_of_California.svg',
    },
    {
      value: 'colorado',
      label: 'Colorado',
      abbr: 'CO',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/4/46/Flag_of_Colorado.svg',
    },
    {
      value: 'connecticut',
      label: 'Connecticut',
      abbr: 'CT',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/9/96/Flag_of_Connecticut.svg',
    },
    {
      value: 'delaware',
      label: 'Delaware',
      abbr: 'DE',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c6/Flag_of_Delaware.svg',
    },
    {
      value: 'district_of_columbia',
      label: 'District of Columbia',
      abbr: 'DC',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/0/03/Flag_of_Washington%2C_D.C.svg',
    },
    {
      value: 'florida',
      label: 'Florida',
      abbr: 'FL',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f7/Flag_of_Florida.svg',
    },
    {
      value: 'georgia',
      label: 'Georgia',
      abbr: 'GA',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/0/08/Flag_of_the_State_of_Georgia.svg',
    },
    {
      value: 'hawaii',
      label: 'Hawaii',
      abbr: 'HI',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/e/ef/Flag_of_Hawaii.svg',
    },
    {
      value: 'idaho',
      label: 'Idaho',
      abbr: 'ID',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a4/Flag_of_Idaho.svg',
    },
    {
      value: 'illinois',
      label: 'Illinois',
      abbr: 'IL',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/0/01/Flag_of_Illinois.svg',
    },
    {
      value: 'indiana',
      label: 'Indiana',
      abbr: 'IN',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/a/ac/Flag_of_Indiana.svg',
    },
    {
      value: 'iowa',
      label: 'Iowa',
      abbr: 'IA',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/a/aa/Flag_of_Iowa.svg',
    },
    {
      value: 'kansas',
      label: 'Kansas',
      abbr: 'KS',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/d/da/Flag_of_Kansas.svg',
    },
    {
      value: 'kentucky',
      label: 'Kentucky',
      abbr: 'KY',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Flag_of_Kentucky.svg',
    },
    {
      value: 'louisiana',
      label: 'Louisiana',
      abbr: 'LA',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/e/e0/Flag_of_Louisiana.svg',
    },
    {
      value: 'maine',
      label: 'Maine',
      abbr: 'ME',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/3/35/Flag_of_Maine.svg',
    },
    {
      value: 'maryland',
      label: 'Maryland',
      abbr: 'MD',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a0/Flag_of_Maryland.svg',
    },
    {
      value: 'massachusetts',
      label: 'Massachusetts',
      abbr: 'MA',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f2/Flag_of_Massachusetts.svg',
    },
    {
      value: 'michigan',
      label: 'Michigan',
      abbr: 'MI',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b5/Flag_of_Michigan.svg',
    },
    {
      value: 'minnesota',
      label: 'Minnesota',
      abbr: 'MN',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b9/Flag_of_Minnesota.svg',
    },
    {
      value: 'mississippi',
      label: 'Mississippi',
      abbr: 'MS',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/4/42/Flag_of_Mississippi.svg',
    },
    {
      value: 'missouri',
      label: 'Missouri',
      abbr: 'MO',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/5/5a/Flag_of_Missouri.svg',
    },
    {
      value: 'montana',
      label: 'Montana',
      abbr: 'MT',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/c/cb/Flag_of_Montana.svg',
    },
    {
      value: 'nebraska',
      label: 'Nebraska',
      abbr: 'NE',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/4/4d/Flag_of_Nebraska.svg',
    },
    {
      value: 'nevada',
      label: 'Nevada',
      abbr: 'NV',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f1/Flag_of_Nevada.svg',
    },
    {
      value: 'new_hampshire',
      label: 'New Hampshire',
      abbr: 'NH',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/28/Flag_of_New_Hampshire.svg',
    },
    {
      value: 'new_jersey',
      label: 'New Jersey',
      abbr: 'NJ',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/9/92/Flag_of_New_Jersey.svg',
    },
    {
      value: 'new_mexico',
      label: 'New Mexico',
      abbr: 'NM',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c3/Flag_of_New_Mexico.svg',
    },
    {
      value: 'new_york',
      label: 'New York',
      abbr: 'NY',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1a/Flag_of_New_York.svg',
    },
    {
      value: 'north_carolina',
      label: 'North Carolina',
      abbr: 'NC',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/b/bb/Flag_of_North_Carolina.svg',
    },
    {
      value: 'north_dakota',
      label: 'North Dakota',
      abbr: 'ND',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/e/ee/Flag_of_North_Dakota.svg',
    },
    {
      value: 'ohio',
      label: 'Ohio',
      abbr: 'OH',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/4/4c/Flag_of_Ohio.svg',
    },
    {
      value: 'oklahoma',
      label: 'Oklahoma',
      abbr: 'OK',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/6/6e/Flag_of_Oklahoma.svg',
    },
    {
      value: 'oregon',
      label: 'Oregon',
      abbr: 'OR',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b9/Flag_of_Oregon.svg',
    },
    {
      value: 'pennsylvania',
      label: 'Pennsylvania',
      abbr: 'PA',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f7/Flag_of_Pennsylvania.svg',
    },
    {
      value: 'rhode_island',
      label: 'Rhode Island',
      abbr: 'RI',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f3/Flag_of_Rhode_Island.svg',
    },
    {
      value: 'south_carolina',
      label: 'South Carolina',
      abbr: 'SC',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/6/69/Flag_of_South_Carolina.svg',
    },
    {
      value: 'south_dakota',
      label: 'South Dakota',
      abbr: 'SD',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1a/Flag_of_South_Dakota.svg',
    },
    {
      value: 'tennessee',
      label: 'Tennessee',
      abbr: 'TN',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/9/9e/Flag_of_Tennessee.svg',
    },
    {
      value: 'texas',
      label: 'Texas',
      abbr: 'TX',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f7/Flag_of_Texas.svg',
    },
    {
      value: 'utah',
      label: 'Utah',
      abbr: 'UT',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f6/Flag_of_Utah.svg',
    },
    {
      value: 'vermont',
      label: 'Vermont',
      abbr: 'VT',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/4/49/Flag_of_Vermont.svg',
    },
    {
      value: 'virginia',
      label: 'Virginia',
      abbr: 'VA',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/4/47/Flag_of_Virginia.svg',
    },
    {
      value: 'washington',
      label: 'Washington',
      abbr: 'WA',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/5/54/Flag_of_Washington.svg',
    },
    {
      value: 'west_virginia',
      label: 'West Virginia',
      abbr: 'WV',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/22/Flag_of_West_Virginia.svg',
    },
    {
      value: 'wisconsin',
      label: 'Wisconsin',
      abbr: 'WI',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/22/Flag_of_Wisconsin.svg',
    },
    {
      value: 'wyoming',
      label: 'Wyoming',
      abbr: 'WY',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/b/bc/Flag_of_Wyoming.svg',
    },
    {
      value: 'american_samoa',
      label: 'American Samoa',
      abbr: 'AS',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/8/87/Flag_of_American_Samoa.svg',
    },
    {
      value: 'guam',
      label: 'Guam',
      abbr: 'GU',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/0/07/Flag_of_Guam.svg',
    },
    {
      value: 'northern_mariana_islands',
      label: 'Northern Mariana Islands',
      abbr: 'MP',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/e/e0/Flag_of_the_Northern_Mariana_Islands.svg',
    },
    {
      value: 'puerto_rico',
      label: 'Puerto Rico',
      abbr: 'PR',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/28/Flag_of_Puerto_Rico.svg',
    },
    {
      value: 'u.s._virgin_islands',
      label: 'U.S. Virgin Islands',
      abbr: 'VI',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f8/Flag_of_the_United_States_Virgin_Islands.svg',
    },
  ],
}
